var url = window.theme?.backendApiUrl || `https://printworks.coi-agency.services`;

class PhotoQuantity {
  constructor(element) {
    this.element = element;
    this.variantMap = new Map();

    // Initialize the variant map from all inputs with name="id"
    this.inputs = this.element.querySelectorAll('.photo__variant__input');
    this.resetMap(); // Initialize the map with existing inputs

    // Remove temporary upload tokens immediately (these should not persist)
    localStorage.removeItem('upload_token');
 //   localStorage.removeItem('upload_timestamp');

     // Listen for security token changes from other tabs
    this.setupCrossTabSync();

    // Check security token usage AFTER a brief delay to avoid race conditions
    this.cartCheckPromise = this.conditionallyRemoveSecurityToken();
  }

async conditionallyRemoveSecurityToken() {
    try {
      // Get current security token from localStorage
      const localSecurityToken = localStorage.getItem("security_token");
      // Fetch the current cart data from Shopify
      // Add cache-busting to prevent stale data on browser back navigation
      const response = await fetch(`/cart.js?t=${Date.now()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache, no-store, must-revalidate",
          "Pragma": "no-cache"
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }

      const cartData = await response.json();

      // Check if cart has the security token in attributes
      const cartSecurityToken =
        cartData.attributes && cartData.attributes.private_cart_property;
      const hasCartSecurityToken =
        cartSecurityToken &&
        cartSecurityToken !== null &&
        cartSecurityToken !== "";
        
      // Check if cart has personalized or photo print items
      const hasPhotoPrint = cartData.items.some(
        (item) => item.properties && item.properties._is_photo_print === "true"
      );
      const hasPersonalized = cartData.items.some(
        (item) => item.properties && item.properties._personalized
      );

      // If cart has security token but no items that need it, clear it
      if (hasCartSecurityToken && !hasPhotoPrint && !hasPersonalized) {

        await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            attributes: {
              private_cart_property: null,
              photo_print_order: null,
            },
          }),
        });

        // Also clear from localStorage
        localStorage.removeItem("security_token");
        this.securityToken = null;
        return true;
      }

      if (hasCartSecurityToken) {
        // Cart has a security token
        if (!localSecurityToken) {
          // Token exists in cart but not in localStorage - recover it
          localStorage.setItem("security_token", cartSecurityToken);
          this.securityToken = cartSecurityToken; // Update instance variable
        } else if (localSecurityToken !== cartSecurityToken) {
          // Tokens don't match - cart is source of truth, update localStorage
          localStorage.setItem("security_token", cartSecurityToken);
          this.securityToken = cartSecurityToken; // Update instance variable
        } else {
          // Tokens match - all good
          console.log("Security token preserved - cart items require it");
        }
      } else {
        // No security token in cart
        if (localSecurityToken) {
          // Token exists locally but not in cart - remove it
          localStorage.removeItem("security_token");
          this.securityToken = null; // Clear instance variabl
        } else {
          // No token anywhere - this is normal for new users
          console.log("No security token needed - user has no cart items");
        }
      }

      // Clean up upload tokens when cart is empty
      if (cartData.item_count === 0) {
        localStorage.removeItem("upload_timestamp");
        localStorage.removeItem("upload_token");
        this.timestamp = null;
        this.uploadToken = null;
      }

      return true; // Return success status
    } catch (error) {
      console.error('Error checking cart for security token usage:', error);
      // On error, err on the side of caution and don't remove the token
      return false; // Return error status
    }

    
  }

    setupCrossTabSync() {
    // Sync security tokens across browser tabs
    window.addEventListener('storage', (e) => {
      if (e.key === 'security_token' && e.newValue) {
        // Another tab updated the security token
        this.securityToken = e.newValue;

        // Also sync timestamp if available
        if (e.storageArea.getItem('upload_timestamp')) {
          this.timestamp = e.storageArea.getItem('upload_timestamp');
        }
      }
    });
  }

  resetMap() {
    this.variantMap.clear(); // Clear the existing map
    this.inputs.forEach(input => {
      const variantId = input.dataset.id;
      const title = input.dataset.name; // data-name holds the title
      const price = input.dataset.price; // data-name holds the title
      const quantity = parseInt(input.dataset.quantity) || 0;
      this.variantMap.set(variantId, { variantId, title, quantity, price });
    });
  }

  resetAllInputs() {
    this.inputs.forEach(input => {
      input.dataset.quantity = 0;
    });
    this.resetMap(); // Reset the map to reflect the cleared inputs
  }

  updateQuantity(direction, id, old_id, quantity_change = 1) {
    if (direction === 'increase') {
      const input = this.element.querySelector(`#id__${id}`);
      if (input) {
        const newQuantity = parseInt(input.dataset.quantity) + quantity_change;
        input.dataset.quantity = newQuantity;
        // Update the map as well
        this.updateMapQ(id, newQuantity);
      }
    } else if (direction === 'decrease') {
      const input = this.element.querySelector(`#id__${id}`);
      if (input) {
        const newQuantity = parseInt(input.dataset.quantity) - quantity_change;
        input.dataset.quantity = newQuantity;
        this.updateMapQ(id, newQuantity);
      }
    } else if (direction === 'change') {
      const input = this.element.querySelector(`#id__${id}`);
      const oldInput = this.element.querySelector(`#id__${old_id}`);
      if (input && oldInput) {
        const newQuantity = parseInt(input.dataset.quantity) + quantity_change;
        const oldNewQuantity = parseInt(oldInput.dataset.quantity) - quantity_change;
        input.dataset.quantity = newQuantity;
        oldInput.dataset.quantity = oldNewQuantity;
        this.updateMapQ(id, newQuantity);
        this.updateMapQ(old_id, oldNewQuantity);
      }
    }
  }


  updateQuantityAll(direction) {
    const allCards = this.element.querySelectorAll(".photo-print__card-wrapper");
    const variantCounts = {};


    if (direction === 'increase') {
      // Old behavior: count selected images
      allCards.forEach(card => {
        const variant = card.dataset.variant;
        const quantityInput = card.querySelector('input[name="quantity"]');
        let currentQty = parseInt(quantityInput.value) || 1;
        if (variant) {
          variantCounts[variant] = (variantCounts[variant] || 0) + currentQty;
        }
      });

      for (const variant in variantCounts) {
        const count = variantCounts[variant];
        const input = this.element.querySelector(`#id__${variant}`);
        if (input) {
          input.dataset.quantity = count;
          this.updateMapQ(variant, count);
        }
      }

    } else if (direction === 'decrease') {
      // Old behavior: reset all to zero
      this.inputs.forEach(input => {
        input.dataset.quantity = 0;
        const variant = input.dataset.id;
        this.updateMapQ(variant, 0);
      });


    }
  }



  updateMapQ(id, quantity) {
    const variantData = this.variantMap.get(id);
    if (variantData) {
      variantData.quantity = quantity;
      this.variantMap.set(id, variantData);
    }
    this.printVariantInfo(); // Call the method to print out variant information
  }

  printVariantInfo() {
    const outputContainer = this.element.querySelector('#images_total');
    if (!outputContainer) return;

    let first = true;
    let totalPrice = 0;
    outputContainer.innerHTML = ''; // Clear existing content

    // Loop over each variant in variantMap
    this.variantMap.forEach(info => {
      if (info.quantity === 0) return; // Only display if quantity > 0

      // Convert price to a number and add to total
      const numericPrice = parseFloat(info.price);
      totalPrice += numericPrice * info.quantity;

      const span = document.createElement('span');
      span.classList.add('u-t3');
      const moneyFormat = window.theme.moneyFormat.replace(/{{[^}]+}}/, '{{ amount }}');
      const price = Shopify.formatMoney(info.price, moneyFormat);

      // Use a separator if more than one info is appended.
      span.textContent = !first
        ? ` | ${info.title} - ${price} x ${info.quantity} pc`
        : `${info.title} - ${price} x ${info.quantity} pc`;

      first = false;
      outputContainer.appendChild(span);
    });

    // If no variant has a quantity above zero, clear the container and disable ATC
    if (totalPrice === 0) {
      outputContainer.innerHTML = '';
      document.querySelectorAll('.product-module__product-atc').forEach(el => {
        el.setAttribute('disabled', 'true');
      });
      // Optionally, clear any displayed total price in the footer.
      document.querySelectorAll('.pp__upload-footer .product-module__atc-price').forEach(el => {
        el.innerHTML = '';
      });
      return;
    } else {
      document.querySelectorAll('.product-module__product-atc').forEach(el => {
        el.removeAttribute('disabled');
      });
    }

    // Append total price to the relevant elements.
    const moneyFormat = window.theme.moneyFormat.replace(/{{[^}]+}}/, '{{ amount }}');
    const totalFormattedPrice = Shopify.formatMoney(totalPrice, moneyFormat);
    document.querySelectorAll('.pp__upload-footer .product-module__atc-price').forEach(el => {
      el.innerHTML = `|&nbsp;${totalFormattedPrice}`;
    });
  }

}

class PhotoPrinting extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.photoQuantity = new PhotoQuantity(this);
    this.uploadedFiles = 0; // Reset uploaded files count
    this.isUpdating = false; //Prevent double clicks when including all images
  }

  connectedCallback() {
    this.timeStampCheck();
    this.init();
    this.checkLoaded();
    this.bindEvents();

  }

  init() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);



    this.photoPrinterStartContent = this.element.querySelector(".photo-printer__content");
    this.imgCardTemplate = this.element.querySelector('#photo-print__card-template');

    this.deleteBtn = this.element.querySelector('.pp__header-remove-btn');
    this.uploadOverlay = this.element.querySelector('.pp__overlay');

    this.itemsToDelete = this.element.querySelector('.pp__delete-count');
    this.itemsToATC = this.element.querySelector('.atc-selected-count');

    this.editPopUp = this.element.querySelector('.fabric-js__popup');

    this.updateFooterHeight();

  }

  updateFooterHeight() {
    const uploadFooterHeight = this.element.querySelector('.pp__upload-footer')?.offsetHeight;
    if (uploadFooterHeight !== undefined) {
      document.documentElement.style.setProperty('--upload-footer-height', `${uploadFooterHeight}px`);
    }
  }
  checkLoaded() {
    var _this = this;


    if (typeof Uppy !== "undefined") {

      this.uppyInit();

    } else {
      loadScript(window.theme.uppyScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }


  }

  async resetUploadToken() {
    const token = localStorage.getItem("upload_token");

    if (!token) {
      console.warn("No upload token found. Skipping deletion.");
      return;
    }

    try {
      // Attempt to delete all files associated with this token
      await apiService.deleteFiles(token, '/api/file/token-delete');

      // Clear localStorage after successful deletion
      localStorage.removeItem("upload_token");


    } catch (error) {
      console.error("Error deleting files before resetting token:", error);
    }
  }


  uppyInit() {
    
    this.maxFileSize = 50 * 1024 * 1024;

    // Initialize Uppy
    this.uppy = new Uppy.Uppy({
      debug: true,
      autoProceed: false,
      restrictions: {
        allowedFileTypes: [
          'image/jpeg', // covers both .jpeg and .jpg
          'image/png',
          'image/heic',
          'image/heif',
          'image/webp'
        ]
      }
    });


    // Use plugins
    this.uppy
      .use(Uppy.FileInput, {
        target: document.body,
        pretty: false
      })
      .use(Uppy.DragDrop, { target: '#file-list--1', id: 'DragDrop1' })
      .use(Uppy.DragDrop, { target: '#file-list--2', id: 'DragDrop2' })
      .use(Uppy.ThumbnailGenerator, {
        thumbnailWidth: 200, 
        waitForThumbnailsBeforeUpload: false
      })
      .use(Uppy.XHRUpload, {
        endpoint: `${url}/api/upload`,
        headers: {},
        credentials: 'include',
        fieldName: 'file'
      });

   

    // Cache FileInput plugin for later
    this.fileInputPlugin = this.uppy.getPlugin('FileInput');

    // File added event
    this.uppy.on("files-added", async (files) => {
      const isExpired = await this.timeStampCheck();
      if (isExpired) {
        // e.g. show a warning / disable upload button
        console.warn("Upload session expired – please refresh your token.");
        return;
      }
      this.initializeUploadUI();
      const title = window.current_variant.title; // e.g. "20x30 cm"

      const [width, height] = title
        .replace(" cm", "")    // Remove the unit
        .split("x")            // Split into ["20", "30"]
        .map(Number);          // Convert to numbers
  
      const variant_ratio = width / height;
  

      
      this.uppy.setMeta({
        desiredRatio: variant_ratio,
        desiredSize: window.current_variant.title,
        uploadToken: this.uploadToken,
        photo_printing: true,
        barcode: window.current_variant.barcode,
      });

      files.forEach(async (file) => {
      await this.uploadFiles(file);
      });
    });

    uppy.on('restriction-failed', (file, error) => {
      if (error && error.message && (error.message.includes('Cannot add the duplicate file') || error.message.includes('already exists'))) {
        const err_msg = window.photoPrinterStrings.err_msg_duplicate;
        setTimeout(() => {
        const uploadStateFooter = this.element.querySelector('.pp__footer-uploade-state');
     
        if (uploadStateFooter) {
          uploadStateFooter.setAttribute('aria-hidden', 'true');
        }

        // Show the default state footer
        const defaultStateFooter = this.element.querySelector('.pp__footer-default-state');

        if (defaultStateFooter) {
          defaultStateFooter.setAttribute('aria-hidden', 'false');
        }
        }, 1000);
          this.showErrorPopup(err_msg, true, 'toggle-popup', window.photoPrinterStrings.skip);
      } 
    });


    // Thumbnail generation
    this.uppy.on('thumbnail:generated', (file, preview) => {
      const card = this.element.querySelector(`[data-file-uppy-id="${file.id}"]`);
      const imgElement = card?.querySelector(".photo-print__card-image");
      if (imgElement) {
        imgElement.src = preview;
      }
    });

    this.bindEventsUppy();
  }

async setTokens() {
    try {
      // Wait for cart check to complete first to avoid race conditions
      if (this.photoQuantity.cartCheckPromise) {
        await this.photoQuantity.cartCheckPromise;
      }

      // Get existing tokens from localStorage (may have been updated by cart check)
      this.securityToken = localStorage.getItem("security_token");
      this.timestamp = localStorage.getItem("upload_timestamp");
      this.uploadToken = localStorage.getItem("upload_token");

      // Check if we need to fetch new tokens
      const needsSecurityToken = !this.securityToken;
      const needsUploadTokens = !this.uploadToken;
      const needsTimestamp = !this.timestamp;

      // If timestamp is missing, we need to fetch security token (which includes timestamp)
      const actuallyNeedsSecurityToken = needsSecurityToken || needsTimestamp;

      if (actuallyNeedsSecurityToken && needsUploadTokens) {
        // Need both security token and upload tokens

        const response = await apiService.getUploadToken('both');

        this.securityToken = response.securityToken;
        this.timestamp = response.timestamp || Date.now().toString();
        this.uploadToken = response.uploadToken;


        // Store all tokens
        if (this.securityToken) {
          localStorage.setItem("security_token", this.securityToken);
        }
        if (this.timestamp) {
          localStorage.setItem("upload_timestamp", this.timestamp);
        } else {
          console.error('ERROR: No timestamp to store!');
        }
        localStorage.setItem("upload_token", this.uploadToken);
        return true;

      } else if (needsUploadTokens && !actuallyNeedsSecurityToken) {
        // Only need upload tokens (security token exists and is valid)
        const response = await apiService.getUploadToken('upload');

        this.uploadToken = response.uploadToken;
        // Keep existing timestamp - don't update it when only fetching upload tokens

        // Store only upload token (timestamp stays unchanged)
        localStorage.setItem("upload_token", this.uploadToken);
        return true;

        } else if (actuallyNeedsSecurityToken && !needsUploadTokens) {
        // Only need security token (upload tokens exist)
        const response = await apiService.getUploadToken("security");

        const existingSecurityToken = localStorage.getItem("security_token");
        const existingTimestamp = localStorage.getItem("upload_timestamp");

        // If security token stays the same, preserve timestamp
        if (existingSecurityToken === response.securityToken && existingTimestamp) {
          this.securityToken = response.securityToken;
          this.timestamp = existingTimestamp;
        } else {
          // Security token changed or no existing timestamp - use new timestamp
          this.securityToken = response.securityToken;
          this.timestamp = response.timestamp || Date.now().toString();
        }

        // Store only security token
        if (this.securityToken) {
          localStorage.setItem("security_token", this.securityToken);
        }

        if (this.timestamp) {
          localStorage.setItem("upload_timestamp", this.timestamp);
        }

        return true;
      } else {
        // All tokens exist
        return true;
      }

    } catch (error) {
      console.error("Error fetching tokens:", error);
      return false;
    }
  }

  async timeStampCheck() {
    let isTimestampExpired = true;
    const storedTimestampStr = localStorage.getItem("upload_timestamp");

    if (storedTimestampStr) {
      const storedTimestamp = parseInt(storedTimestampStr, 10);

      if (!isNaN(storedTimestamp)) {
        const currentTime = Date.now();
        const maxAge = 14 * 24 * 60 * 60 * 1000; // 2 weeks in milliseconds
        isTimestampExpired = (currentTime - storedTimestamp) > maxAge;
      }
    } else {
      console.log('No timestamp found in localStorage');
    }

    if (isTimestampExpired) {
      // Only remove upload-related tokens when expired
      // Keep security token unless specifically determined it's not needed
      localStorage.removeItem("upload_timestamp");
      localStorage.removeItem("upload_token");

      // Reset instance variables for upload tokens
      this.timestamp = null;
      this.uploadToken = null;
      this.tokenPromise = null;

      // Note: We deliberately don't remove security_token here
      // It should only be removed by conditionallyRemoveSecurityToken()

    }

    if (!this.tokenPromise || isTimestampExpired) {
      this.tokenPromise = this.setTokens();
    }

    await this.tokenPromise;
  }

  async handleInvalidTokenError(error) {
    console.log('Handling invalid token error:', error);
    
    try {
      // Check current cart state
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }
      
      const cartData = await response.json();
      
      // Check if cart has items that require security tokens
      const hasPhotoPrint = cartData.items.some(
        item => item.properties && item.properties._is_photo_print === 'true'
      );
      const hasPersonalized = cartData.items.some(
        item => item.properties && item.properties._personalized
      );
      
      const cartNeedsTokens = hasPhotoPrint || hasPersonalized;
      
      if (!cartNeedsTokens || cartData.item_count === 0) {
        // No items need tokens or cart is empty - safe to reset

        await this.resetAllTokens();
        
        // Show success message
        this.showErrorPopup(
          'Session refreshed. You can now proceed with your upload.',
          false,
          'toggle-popup',
          'Continue'
        );
      } else {
        // Cart has items that need tokens - ask user what to do

        this.showTokenConflictDialog(cartData);
      }
      
    } catch (error) {
      console.error('Error handling invalid token:', error);
      // Fallback: just reset tokens
      await this.resetAllTokens();
      this.showErrorPopup(
        'Session expired. Please refresh the page and try again.',
        false,
        'toggle-popup',
        'Close'
      );
    }
  }
  
  async resetAllTokens() {
    // Clear all tokens from localStorage
    localStorage.removeItem('security_token');
    localStorage.removeItem('upload_timestamp');
    localStorage.removeItem('upload_token');
    
    // Clear instance variables
    this.securityToken = null;
    this.timestamp = null;
    this.uploadToken = null;
    this.tokenPromise = null;
    

  }
  
  checkForActiveUploads() {
    // Check if uppy has active uploads
    if (this.uppy) {
      const state = this.uppy.getState();
      const hasFilesUploading = Object.values(state.files).some(file => 
        file.progress && file.progress.uploadStarted && !file.progress.uploadComplete
      );
      
      if (hasFilesUploading) {
        return true;
      }
    }
    
    // Check for any ongoing upload indicators in the UI
    const uploadingElements = this.element.querySelectorAll('[aria-uploading="true"]');
    return uploadingElements.length > 0;
  }
  
  showInvalidTokenDialog({ cartData, cartNeedsTokens, hasActiveUpload, error }) {
    const itemCount = cartData.item_count || 0;
    
    let message = 'Your session has expired and needs to be refreshed.';
    let warningMessage = '';
    
    // Add specific warnings based on current state
    if (hasActiveUpload) {
      warningMessage += '<strong>⚠️ Warning:</strong> You have files currently uploading. Refreshing your session may interrupt this process.<br>';
    }
    
    if (cartNeedsTokens && itemCount > 0) {
      warningMessage += `<strong>📝 Note:</strong> Your cart contains ${itemCount} item${itemCount > 1 ? 's' : ''} that require a valid session.<br>`;
    }
    
    // Create dialog with appropriate options
    let dialogHtml = `
      <div class="invalid-token-dialog">
        <p>${message}</p>
        ${warningMessage ? `<div class="warning-message">${warningMessage}</div>` : ''}
        <p>How would you like to proceed?</p>
        <div class="dialog-buttons">`;
    
    if (cartNeedsTokens && itemCount > 0) {
      // Cart has items that need tokens
      dialogHtml += `
          <button class="btn-clear-cart" data-action="clear-cart-tokens">Clear Cart & Refresh Session</button>
          <button class="btn-checkout" data-action="proceed-checkout">Proceed to Checkout</button>`;
    } else {
      // Cart is empty or no items need tokens
      dialogHtml += `
          <button class="btn-refresh-session" data-action="refresh-session-only">Refresh Session</button>`;
    }
    
    dialogHtml += `
          <button class="btn-cancel" data-action="toggle-popup">Cancel</button>
        </div>
      </div>
    `;
    
    // Show in error popup but with custom content  
    const popup = this.element.querySelector('#modal-pp-error');
    const errMsg = popup.querySelector('.pp__error-msg');
    errMsg.innerHTML = dialogHtml;
    
    // Add event listeners for custom actions
    this.addInvalidTokenListeners();
    
    window.globalPopup.openPopup(popup, true);
  }
  
  addInvalidTokenListeners() {
    this.delegateElement.on('click', '[data-action="clear-cart-tokens"]', async () => {
      await this.clearCartAndResetTokens();
    });
    
    this.delegateElement.on('click', '[data-action="refresh-session-only"]', async () => {
      await this.refreshSessionOnly();
    });
    
    this.delegateElement.on('click', '[data-action="proceed-checkout"]', () => {
      window.location.href = '/cart';
    });
  }
  
  async refreshSessionOnly() {
    try {
      // Reset all tokens
      await this.resetAllTokens();
      
      // Close popup and show success
      const popup = this.element.querySelector('#modal-pp-error');
      window.globalPopup.closePopup(popup);
      
      this.showErrorPopup(
        'Session refreshed successfully. You can now proceed with your photo printing.',
        false,
        'toggle-popup',
        'Continue'
      );
      
    } catch (error) {
      console.error('Error refreshing session:', error);
      this.showErrorPopup(
        'Error refreshing session. Please try refreshing the page.',
        false,
        'toggle-popup',
        'Close'
      );
    }
  }
  
  async clearCartAndResetTokens() {
    try {
      // Clear the cart
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      // Reset all tokens
      await this.resetAllTokens();
      
      // Close popup and show success
      const popup = this.element.querySelector('#modal-pp-error');
      window.globalPopup.closePopup(popup);
      
      this.showErrorPopup(
        'Session refreshed. You can now proceed with your upload.',
        false,
        'toggle-popup',
        'Continue'
      );
      
    } catch (error) {
      console.error('Error clearing cart:', error);
      this.showErrorPopup(
        'Error clearing cart. Please try refreshing the page.',
        false,
        'toggle-popup',
        'Close'
      );
    }
  }

  async uploadFiles(file) {
    // Check the file size

    if (file.size > this.maxFileSize) {
      const err_msg = window.photoPrinterStrings.errMsgLimit;
      this.showErrorPopup(err_msg, true);
      this.uppy.removeFile(file.id);
      return;
    }


    this.displaySelectedFile(file);

    await this.handleFileUpload();



    this.tokenPromise = null;
  }


  bindEvents() {



    this.delegateElement.on(
      "click",
      '#select-device',
      this.triggerFileInputClick.bind(this)
    );
    this.delegateElement.on('click', '[data-action="upload-again-err"]', this.uploadAgain.bind(this));

    this.delegateElement.on(
      "click",
      '[data-action="toggle-checkbox"]',
      this.toggleCheckboxForImg.bind(this)
    );

    this.delegateElement.on(
  "change",
  "#select-all-imgs input[type='checkbox']",
  this.toggleSelectAll.bind(this)
);

    this.delegateElement.on(
      "click",
      '[data-action="delete-selected-imgs"]',
      this.handleDeleteMethod.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="remove-item"]',
      this.handleDeleteMethod.bind(this)
    )

    this.delegateElement.on(
      "click",
      '[data-action="edit-img"]',
      this.editImgHandle.bind(this)
    );


    this.delegateElement.on(
      "click",
      '[data-action="quantity-decrease"]',
      this.itemQuantityDec.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="quantity-increase"]',
      this.itemQuantityInc.bind(this)
    );

    this.delegateElement.on(
      'change',
      'input[name="quantity"]',
      this.itemQuantityInputChange.bind(this)
    );

    this.delegateElement.on(
      'update:main-atc',
      this.handleVariantChange.bind(this)
    );

    this.delegateElement.on('click', '[data-action="exit-intent"]', this.exitIntent.bind(this));

  }

  bindEventsUppy() {

    function handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = '';
    }

    this.delegateBody.on("reset:reset-upload", () => {
      this.goBackToStart();           // Existing reset behavior
    });

    window.globalPopup.onPopupOpen = function (popupElement) {
      if (popupElement.id === 'modal-upload-photos') {
        //   window.addEventListener('beforeunload', handleBeforeUnload);
      }
    };

    window.globalPopup.onPopupClose = function (popupElement) {
      if (popupElement.id === 'modal-upload-photos') {
        //    window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    };



    this.uppy.on("upload-progress", this.updateUploadProgress.bind(this));
    this.uppy.on("upload-success", this.handleUploadSuccess.bind(this));
  }

  // Then add this new method to your PhotoPrinting class:
  itemQuantityInputChange(event) {
    const input = event.target;
    // Parse and ensure a minimum value of 1
    let newQty = parseInt(input.value, 10);
    if (isNaN(newQty) || newQty < 1) {
      newQty = 1;
      input.value = newQty;
    }

    // Get the image card (container) that holds the input and its variant data
    const card = input.closest('.photo-print__card-wrapper');
    if (!card) return;
    const variantId = card.dataset.variant;

    // Recalculate the total quantity for this variant by summing quantities from all cards with the same variant
    let totalQuantity = 0;
    const cardsForVariant = this.element.querySelectorAll(
      `.photo-print__card-wrapper[data-variant="${variantId}"]`
    );
    cardsForVariant.forEach(c => {
      const qtyInput = c.querySelector('input[name="quantity"]');
      totalQuantity += parseInt(qtyInput.value, 10) || 0;
    });

    // Update the hidden input that holds the overall quantity for this variant (if such an input exists)
    const hiddenInput = this.element.querySelector(`#id__${variantId}`);
    if (hiddenInput) {
      hiddenInput.dataset.quantity = totalQuantity;
    }

    // Update the variantMap with the new total quantity.
    this.photoQuantity.updateMapQ(variantId, totalQuantity);

    // Optionally update the metadata for the current image
    const fileServerId = card.dataset.fileServerId;
    if (fileServerId) {
      this.updateMetadataQuantity(fileServerId, newQty);
    }
  }

  uploadAgain(event) {

    const popup = event.target.closest('#modal-pp-error');

    if (popup) {
      window.globalPopup.closePopup(popup);
    }

    if (this.uploadOverlay?.classList.contains('is-visible')) {
      this.uploadOverlay.classList.remove('is-visible');
    }

    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-upload-photos');
    }
   
  }




  async exitIntent() {
    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-upload-photos');
    }

    const token = localStorage.getItem("upload_token");
    if (token) {
      apiService.deleteFiles(token, '/api/file/token-delete')
        .then(result => {
        })
        .catch(error => console.error('Error deleting files:', error));
    }

    localStorage.removeItem("upload_token");
    window.globalPopup.closeAllPopups();
    bodyScrollLock.clearAllBodyScrollLocks();
    await this.goBackToStart();
  }

  handleVariantChange(event) {
    const { cardId, variantId, variantValue } = event.detail;

    // Find the image card by the uppy ID
    const imgCard = this.element.querySelector(`[data-file-uppy-id="${cardId}"]`);

    if (!imgCard) {
      console.warn(`No image card found with data-file-uppy-id="${cardId}"`);
      return;
    }

    // Update the data-variant attribute
    const oldVariant = imgCard.getAttribute('data-variant');
    imgCard.setAttribute('data-variant', variantId);

    // Update the label text
    const variantLabel = imgCard.querySelector('.photo-print__card-variant-lbl');
    if (variantLabel) {
      variantLabel.textContent = variantValue;
    } else {
      console.warn('Variant label element not found in image card');
    }

    const quantity = parseInt(imgCard.querySelector('input[name="quantity"]').value) || 1;
    if (variantId == oldVariant) return;
    // 4. Trigger full update of all variant quantities in the form
    this.photoQuantity.updateQuantity('change', variantId, oldVariant, quantity);
  }

  itemQuantityDec(event) {
    const btn = event.target.closest('button');
    const card = btn.closest('.photo-print__card-wrapper');
    if (!card) return;

    const variantId = card.dataset.variant;
    const quantityInput = card.querySelector('input[name="quantity"]');
    let currentQty = parseInt(quantityInput.value) || 1;

    if (currentQty > 1) {
      currentQty--;
      quantityInput.value = currentQty;
      this.updateMetadataQuantity(card.dataset.fileServerId, currentQty);
      // Update hidden input + PhotoQuantity map
      this.photoQuantity.updateQuantity('decrease', variantId, currentQty);
    }

    // Disable the minus button if quantity is 1
    if (currentQty === 1) {
      btn.setAttribute('disabled', '');
    }
  }

  itemQuantityInc(event) {
    const btn = event.target.closest('button');
    const card = btn.closest('.photo-print__card-wrapper');
    if (!card) return;



    // Ensure the minus button is enabled on increase
    const minusBtn = card.querySelector('button[data-action="quantity-decrease"]');
    if (minusBtn) {

      minusBtn.removeAttribute('disabled');
    }

    const variantId = card.dataset.variant;
    const quantityInput = card.querySelector('input[name="quantity"]');
    let currentQty = parseInt(quantityInput.value) || 1;

    currentQty++;
    quantityInput.value = currentQty;
    this.updateMetadataQuantity(card.dataset.fileServerId, currentQty);
    // Update hidden input + PhotoQuantity map
    this.photoQuantity.updateQuantity('increase', variantId, currentQty);
  }

  async updateMetadataQuantity(filename, new_quantity) {
    const updates = { quantity: new_quantity };

    try {
      // Optionally await for metadata update to finish
      const result = await apiService.updateMetadata(filename, updates);
      if (result.error) {
        console.error("Error updating metadata:", result.error, result.details);
      } else {
        console.log("Metadata updated successfully:", result);
      }
    } catch (error) {
      console.error("Error updating metadata:", error);
    }
  }

  async editImgHandle(event) {
    const fileId = event.target.closest('[data-file-server-id]').getAttribute('data-file-server-id');
    const fileUrl = event.target.closest('[data-file-server-id]').getAttribute('data-edit-url');
    const targetButton = event.target;
    const imgCard = event.target.closest('.photo-print__card-wrapper');
    const variantValue = imgCard.querySelector('.photo-print__card-variant-lbl').textContent;
    
    // Get imgCardId from the parent
    const imgCardId = event.target.closest('[data-file-uppy-id]').getAttribute('data-file-uppy-id');

    // Check if the current file ID is already in the popup
    const currentImageUrl = this.editPopUp.getAttribute('data-img-url');

    this.initSelectboxVariant(variantValue);
    // If the file ID is the same as the one already in the popup, do nothing
    if (currentImageUrl && currentImageUrl.includes(fileId)) {
      this.element.dispatchEvent(
        new CustomEvent("edit-img:pressed", {
          bubbles: true,
          detail: {
            eventName: "edit-img-btn",
            button: targetButton,
            imgCardId: imgCardId
          },
        })
      );
      return;  // Skip fetching if the same image is already loaded
    }


    const togglePopup = this.element.querySelector('#modal-edit-img');
    const loader = togglePopup.querySelector('.spinningLoader');
    window.globalPopup.openPopup(togglePopup, true);
    loader.classList.add('is-visible');


    // Fetch the original image URL based on the file ID
    await this.fetchOriginalImageUrl(fileId, targetButton, fileUrl, imgCardId);
    loader.classList.remove('is-visible');


  }

  // Function to fetch the original image URL from the server
  async fetchOriginalImageUrl(fileId, targetButton, fileUrl, imgCardId) {
    try {

      const completeUrl = fileUrl;

      // Ensure we have both token and timestamp for security
      if (!this.securityToken || !this.timestamp) {
        throw new Error("Token or timestamp is missing.");
      }


      // Make GET request to fetch the image
      const response = await fetch(completeUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.securityToken}`,
          "Content-Type": "application/json",
          "x-upload-timestamp": this.timestamp,  // Include timestamp for protection
          'ngrok-skip-browser-warning': 'true'

        }
      });

      // Check if the response is successful
      if (!response.ok) {
        throw new Error("Failed to fetch the image.");
      }

      // Get the image as a Blob
      const imageBlob = await response.blob();  // Get the image as a Blob
      const imageUrl = URL.createObjectURL(imageBlob);
      if (imageUrl) {
        // Call the method to save the image URL as an attribute of the popup
        this.saveImageUrlAsPopupAttribute(imageUrl, fileId);

        // Assuming you want to dispatch an event with the image URL
        this.element.dispatchEvent(
          new CustomEvent("edit-img:pressed", {
            bubbles: true,
            detail: {
              eventName: "edit-img-btn",
              button: targetButton,
              imgCardId: imgCardId
            },
          })
        );
      } else {
        throw new Error("Failed to retrieve image URL.");
      }
    } catch (error) {
      console.error("Error fetching the image:", error);
      alert("An error occurred while fetching the image.");
    }
  }

  saveImageUrlAsPopupAttribute(originalImageUrl, fileId) {

    if (this.editPopUp) {
      // Store the image URL as a custom data attribute on the popup
      this.editPopUp.setAttribute('data-img-url', originalImageUrl);
      this.editPopUp.dataset.name = fileId;
    } else {
      console.error('Popup element not found');
    }
  }

  async toggleSelectAll(event) {
    if (this.isUpdating) return;
    this.isUpdating = true; // Set flag
    const isChecked = event.target.checked;
    const allCards = this.element.querySelectorAll(".photo-print__card-wrapper");
    const label = event.target.closest('label');
    label.style.pointerEvents = "none";

    allCards.forEach(card => {
      const filledIcon = card.querySelector(".checked-icon.filled");
      const unfilledIcon = card.querySelector(".checked-icon.unfilled");

      if (isChecked) {
        card.setAttribute("aria-selected", "true");
        filledIcon.classList.remove("hidden");
        unfilledIcon.classList.add("hidden");
        this.enableDeleteBtn();

      } else {
        card.setAttribute("aria-selected", "false");
        filledIcon.classList.add("hidden");
        unfilledIcon.classList.remove("hidden");
        this.disableDeleteBtn();

      }
    });

    if (isChecked) {
      this.photoQuantity.updateQuantityAll('increase');
    } else {
      this.photoQuantity.updateQuantityAll('decrease');
    }

    const updates = { updateall: isChecked ? "true" : "false" };

    try {
      // Optionally await for metadata update to finish
      const result = await apiService.updateMetadata(false, updates);
      if (result.error) {
        console.error("Error updating metadata:", result.error, result.details);
      } else {
        console.log("Metadata updated successfully:", result);
      }
    } catch (error) {
      console.error("Error updating metadata:", error);
    } finally {
    this.isUpdating = false; // Reset flag
    label.style.pointerEvents = "all"; // Re-enable pointer events
    }

  }

  enableDeleteBtn() {
    this.deleteBtn.removeAttribute('disabled');
  }

  disableDeleteBtn() {
    this.deleteBtn.setAttribute('disabled', 'true')
  }

  async toggleCheckboxForImg(event) {
    event.preventDefault();
    const cardWrapper = event.target.closest(".photo-print__card-wrapper");
    if (!cardWrapper) return;

    // Destructure useful data from the card wrapper
    const { variant, fileServerId: filename } = cardWrapper.dataset;
    const filledIcon = cardWrapper.querySelector(".checked-icon.filled");
    const unfilledIcon = cardWrapper.querySelector(".checked-icon.unfilled");
    const isSelected = cardWrapper.getAttribute("aria-selected") === "true";

    // Determine new state and corresponding update values
    const newState = !isSelected;
    cardWrapper.setAttribute("aria-selected", newState.toString());
    const quantityInput = cardWrapper.querySelector('input[name="quantity"]');
    const currentQty = parseInt(quantityInput.value) || 1;

    if (newState) {
      // When selecting the image
      filledIcon.classList.remove("hidden");
      unfilledIcon.classList.add("hidden");
      this.photoQuantity.updateQuantity("increase", variant, null, currentQty);
    } else {
      // When deselecting the image
      unfilledIcon.classList.remove("hidden");
      filledIcon.classList.add("hidden");
      this.photoQuantity.updateQuantity("decrease", variant, null, currentQty);
    }

    // Define the metadata update: adjust included based on new state
    const updates = { included: newState ? "true" : "false" };

    try {
      // Optionally await for metadata update to finish
      const result = await apiService.updateMetadata(filename, updates);
      if (result.error) {
        console.error("Error updating metadata:", result.error, result.details);
      } else {
        console.log("Metadata updated successfully:", result);
      }
    } catch (error) {
      console.error("Error updating metadata:", error);
    }

    // Update "Select All" checkbox based on current selection state of all images
    this.updateSelectAllCheckbox();
  }


  updateSelectAllCheckbox() {
    const allCards = this.element.querySelectorAll(".photo-print__card-wrapper");
    const selectedCards = this.element.querySelectorAll(
      '.photo-print__card-wrapper[aria-selected="true"]'
    );



    const selectAllCheckbox = this.element.querySelector("#select-all-imgs input[type='checkbox']");
    this.itemsToDelete.textContent = selectedCards.length;
    this.itemsToATC.textContent = selectedCards.length;

    // If all images are selected, check "Select All"; otherwise, uncheck it
    selectAllCheckbox.checked = allCards.length === selectedCards.length;

    if (selectedCards.length === 0)
      this.disableDeleteBtn();
    else
      this.enableDeleteBtn();

  }

  async handleDeleteMethod(event) {
    const filenames = this.getFilesToBeDeleted(event);
    const poupToClose = this.element.querySelector('#modal-delete-conf')
    window.globalPopup.closePopup(poupToClose);
    await this.deleteSelectedImgs(filenames);
  }

  getFilesToBeDeleted(event) {
    const eventType = event.target.getAttribute('data-action'); // Identify event type
    if (!eventType) return [];

    if (eventType === "remove-item") {
      const parentElement = event.target.closest("[data-file-server-id]");
      return parentElement ? [parentElement.dataset.fileServerId] : [];
    }

    if (eventType === "delete-selected-imgs") {
      return Array.from(this.element.querySelectorAll(`.photo-print__card-wrapper[aria-selected="true"]`))
        .map(img => img.dataset.fileServerId)
        .filter(Boolean);
    }
    return [];

  }

  async deleteSelectedImgs(filenames) {
    try {

      const response = await fetch(`${url}/api/files/${this.securityToken}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.securityToken}`,
          "Content-Type": "application/json",
          "x-upload-timestamp": this.timestamp
        },
        body: JSON.stringify({ filenames }) // Send filenames as an array
      });

      if (!response.ok) {
        throw new Error("Failed to delete selected files.");
      }

      // Remove deleted files from Uppy
      filenames.forEach(filename => {
        // Find the element with `data-file-server-id` matching the filename
        const element = this.element.querySelector(`[data-file-server-id="${filename}"]`);

        // Extract the corresponding Uppy file ID from `data-file-uppy-id`
        if (element) {
          const uppyFileId = element.getAttribute('data-file-uppy-id');

          // Remove the file from Uppy
          if (uppyFileId) {
            this.uppy.removeFile(uppyFileId);
          }
        }
      });


      //  Call the new `updateUI` function to remove files from the frontend
      this.deletingImgUI(filenames);

    } catch (err) {
      console.error("Error during file deletion:", err);
      alert("An error occurred while deleting the file(s).");
    }
  }


  deletingImgUI(filenames) {
    filenames.forEach((filename) => {
      const parentElement = this.element.querySelector(`[data-file-server-id="${filename}"]`);
      if (parentElement) {
        const variantId = parentElement.dataset.variant; // <--- grab variant ID

        parentElement.classList.add('removing');

        // Wait for the CSS animation to finish before removing the element
        parentElement.addEventListener('transitionend', async () => {
          parentElement.remove();

            // Decrement the uploaded files counter for each deleted file.
        // (Adjust this value only if the file had been already fully uploaded.)
        this.uploadedFiles = Math.max(this.uploadedFiles - 1, 0);

          // ✅ Decrement quantity input and update PhotoQuantity
          const quantityInput = this.element.querySelector(`#id__${variantId}`);
          const cardQuantityInput = parentElement.querySelector('input[name="quantity"]');
          if (quantityInput && cardQuantityInput) {
            const cardQty = parseInt(cardQuantityInput.value) || 1;
            const currentTotal = parseInt(quantityInput.dataset.quantity) || 0;
            const newQty = Math.max(currentTotal - cardQty, 0);

            quantityInput.dataset.quantity = newQty;
            this.photoQuantity.updateMapQ(variantId, newQty);

          }


          // After the element is removed, check if all .photo-print__card-wrapper elements are gone
          const allCards = this.element.querySelectorAll('.photo-print__card-wrapper');
          if (allCards.length === 0) {
            // If no more card wrappers, show .photo-printer__content again and remove .pp__uploaded-content
            await this.goBackToStart();
          } else {
            // **Update the delete all button state and selected count**
            this.updateSelectAllCheckbox();
          }
          // **Update the delete all button state and selected count**
          this.updateSelectAllCheckbox();
          this.updateFooterHeight();
        }, { once: true }); // `once: true` ensures the event listener is automatically removed
      }
    });

    this.updateTotalFilesCount();
  }

  async goBackToStart() {
    const [
      uploadedContent,
      defaultStateFooter,
      uploadStateFooter
    ] = this.element.querySelectorAll(`
        .pp__uploaded-content, 
        .pp__footer-default-state, 
        .pp__footer-uploade-state
      `);

    // Hide uploaded content and clear its grid
    if (uploadedContent) {
      uploadedContent.setAttribute("inert", "");
      const grid = uploadedContent.querySelector('.pp__images-grid');
      if (grid) grid.innerHTML = "";
    }

    // Show start content
    this.photoPrinterStartContent?.removeAttribute("inert");

    // Toggle footers
    defaultStateFooter?.setAttribute('aria-hidden', 'true');
    uploadStateFooter?.setAttribute('aria-hidden', 'false');

    // Reset the aria-controls attribute on the close button back to default ("modal-upload-photos")
    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-upload-photos');
    }



    // Reset Uppy state
    this.uploadedFiles = 0;
    this.uppy.clear();

    this.updateFooterHeight();
    this.photoQuantity.resetAllInputs();
    this.photoQuantity.resetMap();
    await this.resetUploadToken();
  }



  async handleFileUpload() {
 
    const xhrUpload = this.uppy.getPlugin("XHRUpload");
    xhrUpload.setOptions({
      headers: {
        Authorization: `Bearer ${this.securityToken}`,
        "x-upload-timestamp": this.timestamp
      }
    });

    try {
      const result = await this.uppy.upload();

      if (result.failed && result.failed.length > 0) {
        const firstError = result.failed[0].error?.message || result.failed[0].error || "Some files failed to upload.";
        this.showErrorPopup(firstError, true);
      }

      result.successful.forEach(file => {
        const uploadedFile = file.response.body;
        const oldFilename = file.id;
        const newFilename = uploadedFile.original;

        let fileExtension = '';
        // Check if file.name exists before trying to access it
        if (file.name) {
            const lastDotIndex = file.name.lastIndexOf('.');
            // Ensure a dot exists and it's not the last character
            if (lastDotIndex !== -1 && lastDotIndex < file.name.length - 1) {
                fileExtension = file.name.substring(lastDotIndex + 1).toLowerCase();
            }
        }
    
      // For HEIC/HEIF images, process the image using the new method.
      if (file.meta.type === 'image/heic' || file.meta.type === 'image/heif' || fileExtension === 'heic' || fileExtension === 'heif') {
        const cardImg = this.element.querySelector(`[data-file-uppy-id="${oldFilename}"] img`);
        if (cardImg) {
          this.processHeicThumbnail(cardImg, file, uploadedFile.url);
        }
      }


        const fileElement = this.element.querySelector(`[data-file-uppy-id="${oldFilename}"]`);
        if (fileElement) {
          fileElement.setAttribute("data-file-server-id", newFilename);
          fileElement.setAttribute("data-edit-url", uploadedFile.url);
          fileElement.setAttribute("data-variant", window.current_variant.id);
        }
      });

    } catch (err) {
      const errorMessage = err?.message || "An unexpected error occurred during upload.";
      this.showErrorPopup(errorMessage, true); // Catch unexpected upload errors
    }
  }

  async processHeicThumbnail(cardImg, file, uploadedFileUrl) {
    try {
      const response = await fetch(uploadedFileUrl, {
        headers: {
          Authorization: `Bearer ${this.securityToken}`,
          "x-upload-timestamp": this.timestamp
        }
      });
      if (!response.ok) {
        throw new Error("Failed to fetch image preview for HEIC.");
      }
      const blob = await response.blob();
      const originalUrl = URL.createObjectURL(blob);

      const tempImg = new Image();
      tempImg.crossOrigin = 'Anonymous';
      tempImg.src = originalUrl;
      tempImg.onload = () => {
        const targetWidth = 200;
        const aspectRatio = tempImg.naturalWidth / tempImg.naturalHeight;
        const targetHeight = targetWidth / aspectRatio;

        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(tempImg, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((compressedBlob) => {
          if (compressedBlob) {
            const compressedUrl = URL.createObjectURL(compressedBlob);
            const cardEl = cardImg.closest('.photo-print__card-wrapper');
            if (cardEl) {
                this.generateThumbnail(cardImg, compressedUrl, cardEl);
                cardImg.dataset.thumbnailApplied = 'true'; // Mark as applied here for HEIC
            } else {
                console.error("processHeicThumbnail: Could not find parent card element for HEIC image.");
            }
          } else {
            console.error('HEIC Canvas conversion returned null blob.');
          }
          URL.revokeObjectURL(originalUrl); // Revoke original blob URL
          // Note: compressedUrl should be revoked later if needed, perhaps when the card is removed
        }, 'image/jpeg', 0.7);
      };

      tempImg.onerror = (err) => {
        console.error("Error loading temporary HEIC image:", err);
        URL.revokeObjectURL(originalUrl);
      };
    } catch (err) {
      console.error("Error processing HEIC image thumbnail:", err);
    }
  }
  
  

  showErrorPopup(err, closeChilds = false, action = 'upload-again-err', exitString = window.photoPrinterStrings.cancel) {
    if (closeChilds == true) {
      const childsPopup = this.element.querySelectorAll('.popup-inside-popup');
      childsPopup.forEach(popup => {
        if (popup.getAttribute('aria-expanded') === 'true') {
          window.globalPopup.closePopup(popup);
        }
      });
    }
    const popup = this.element.querySelector('#modal-pp-error');
    const errMsg = popup.querySelector('.pp__error-msg');
    errMsg.textContent = err;

    const ButtonText = this.element.querySelectorAll('.pp__exit-btn .ButtonText');
    if (ButtonText) {
      ButtonText.forEach(btn => {
        btn.textContent = exitString;
      });
    }

    if(action == 'toggle-popup'){
    popup.querySelector('.pp__action-btn').style.display = 'none';
    window.globalPopup.openPopup(popup, true);
    
    } else {
          popup.querySelector('.pp__action-btn').style.display = 'block';
    popup.querySelector('.pp__action-btn').setAttribute('data-action', action);
    window.globalPopup.openPopup(popup, true);
    }



  }


  initializeUploadUI() {
  
    this.element.setAttribute("aria-uploading", "true");
    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-exit');
    }
    const popupUploadMore = this.element.querySelector('#modal-more-imgs');
    // 👇 Check if popup is open and trigger close
    if (popupUploadMore && popupUploadMore.getAttribute('aria-expanded') === 'true') {
      const toggleButton = popupUploadMore.querySelector('[data-action="toggle-popup"]');
      if (toggleButton) {
        toggleButton.click();
      }
    }

    this.globalFill = this.element.querySelector(".photo-print__global-fill");
    this.uploadedCountEl = this.element.querySelector(".pp__uploaded-count");
    this.totalCountEls = this.element.querySelectorAll(".pp__img-count-total");

    this.updateTotalFilesCount(); // Initialize count


    this.uploadedCountEl.textContent = this.uploadedFiles;

    this.globalFill.style.width = `${this.uploadedFiles / this.totalFiles * 100}%`;


    if (this.uploadOverlay) {
      this.uploadOverlay.classList.add('is-visible');
    }


    const defaultStateFooter = this.element.querySelector('.pp__footer-default-state');
    if (defaultStateFooter) {
      defaultStateFooter.setAttribute('aria-hidden', 'true');
    }


    const uploadStateFooter = this.element.querySelector('.pp__footer-uploade-state');
    if (uploadStateFooter) {
      uploadStateFooter.setAttribute('aria-hidden', 'false');
    }

    this.updateFooterHeight();

  }

  updateTotalFilesCount() {
    this.totalFiles = this.uppy.getFiles().length;
    this.totalCountEls.forEach(el => el.textContent = this.totalFiles);
  }

  updateUploadProgress(file, progress) {
    const card = document.querySelector(`[data-file-uppy-id="${file.id}"]`);
    if (card) {
      let percentage = Math.round((progress.bytesUploaded / progress.bytesTotal) * 100);
      const statusElement = card.querySelector(".pp__upload-percentage-value");
      if (percentage === 99) {
        card.querySelector('.pp__img-overlay').classList.add('pp__border');
      }

if (percentage === 100) {
  percentage = 99; // Set to 99% for the final state
      }

      statusElement.textContent = `${percentage}%`;
    }
  }

  handleUploadSuccess(file) {
    this.uploadedFiles++;
    this.uploadedCountEl.textContent = this.uploadedFiles;

    const progressPercent = (this.uploadedFiles / this.totalFiles) * 100;
    this.globalFill.style.width = `${progressPercent}%`;

    const card = this.element.querySelector(`[data-file-uppy-id="${file.id}"]`);



    if (card) {
      const statusElement = card.querySelector(".pp__upload-percentage-value");
      const overlayEl = card.querySelector(".pp__img-overlay");
      const checkboxLabel = card.querySelector(".pp__card-checkbox-label"); // Added checkbox label reference

      statusElement.style.opacity = "0";
      overlayEl.style.opacity = "0";

      //  Show the checkbox label when upload is complete
      if (checkboxLabel) checkboxLabel.style.opacity = "1";

    }



    if (this.uploadedFiles === this.totalFiles) {


  

    
      this.initSelectboxVariant();
      const uploadTokenInput = this.element.querySelector('#custom_property');



      if (uploadTokenInput) {
        uploadTokenInput.value = this.uploadToken;
      }

      const order_token = localStorage.getItem("security_token");
      const orderTokenInput = this.element.querySelector('#order_token');
      if (orderTokenInput) {
        orderTokenInput.value = order_token;
      }


    }
    setTimeout(() => {
            if (this.uploadedFiles === this.totalFiles) {

      this.updateUploadFoter();
            }

    }, 2000); //by design
  }

  updateUploadFoter(){

  // Check if all files are uploaded

        // Hide the upload state footer
        const uploadStateFooter = this.element.querySelector('.pp__footer-uploade-state');
        if (uploadStateFooter) {
          uploadStateFooter.setAttribute('aria-hidden', 'true');
        }

        // Show the default state footer
        const defaultStateFooter = this.element.querySelector('.pp__footer-default-state');
        if (defaultStateFooter) {
          defaultStateFooter.setAttribute('aria-hidden', 'false');
        }

        if (this.uploadOverlay) {
          this.uploadOverlay.classList.remove('is-visible');
          this.element.setAttribute("aria-uploading", "false");

        }
        // Check if all images are selected and update "Select All"
        this.updateSelectAllCheckbox();
        this.updateFooterHeight();
        new AddToCart(this.element);
        
        this.photoQuantity.updateQuantityAll('increase');

  }



  initSelectboxVariant(variant) {
    const selectElement = this.element.querySelector('.fjs__variant-select');
    const newValue = variant || window.current_variant?.title;
    if (!selectElement || !newValue) return;

    // Clear current selection for the hidden select
    const options = Array.from(selectElement.options);
    options.forEach(option => {
      option.removeAttribute('selected');
    });

    // Find and select the matching option by comparing trimmed values
    const matchingOption = options.find(option => option.value.trim() === newValue.trim());
    if (!matchingOption) return;
    matchingOption.setAttribute('selected', true);

    // Update the visible text in the custom selectbox title
    const titleElement = this.element.querySelector('.RevolutionSelectbox--Title');
    if (titleElement) {
      titleElement.textContent = newValue;
    }

    // Update the custom button state by disabling the button that matches newValue
    const buttonItems = this.element.querySelectorAll('.RevolutionSelectbox--Item[data-selectboxid="Size"]');
    buttonItems.forEach(button => {
      if (button.getAttribute('data-value').trim() === newValue.trim()) {
        button.setAttribute('disabled', 'true');
      } else {
        button.removeAttribute('disabled');
      }
    });

  }



  triggerFileInputClick() {
    this.fileInputPlugin.input.click();
  }

  displaySelectedFile(file) {

    // Update inert attributes and reveal overlay
    if (this.photoPrinterStartContent) {
      this.photoPrinterStartContent.setAttribute("inert", "");
    }
    if (this.uploadOverlay) {
      this.uploadOverlay.classList.add('is-visible');
    }
    const uploadedContent = this.element.querySelector(".pp__uploaded-content");
    if (uploadedContent) {
      uploadedContent.removeAttribute("inert");
    }

    // Get the images grid container
    const imgList = this.element.querySelector(".pp__images-grid");
    if (!imgList) {
        console.error("displaySelectedFile: Cannot find .pp__images-grid");
        return;
    }

    // --- Check current_variant ---
    const currentVariant = window.current_variant;
    if (!currentVariant) {
        console.error(`displaySelectedFile [${file.id}]: window.current_variant is not defined when adding file!`);
        return; // Cannot proceed without variant info
    }



    const title = currentVariant.title;
    const variantId = currentVariant.id;
    const selectedRatioString = currentVariant.ratio_value; // Get the intended ratio string

    // Clone the image card template
    const clone = document.importNode(this.imgCardTemplate.content, true);

    // Update the variant label if it exists
    const variantLabel = clone.querySelector('.photo-print__card-variant-lbl');
    if (variantLabel) {
      variantLabel.textContent = title || 'N/A'; // Use title or fallback
    }

    // Obtain the card element and image element in the clone
    const cardEl = clone.querySelector('.photo-print__card-wrapper');
    const imgElement = clone.querySelector(".photo-print__card-image");

    if (cardEl) {
      cardEl.dataset.fileUppyId = file.id;
      cardEl.dataset.variantId = variantId;
      // Store the selected ratio string; fallback to '1/1' ONLY if it's genuinely missing/invalid
      cardEl.dataset.selectedRatio = selectedRatioString || '1/1';

  
    } else {
       console.error(`displaySelectedFile [${file.id}]: Could not find .photo-print__card-wrapper in template clone.`);
    }

    if (imgElement) {
      imgElement.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="; // Placeholder
      imgElement.dataset.thumbnailApplied = 'false'; // Flag to prevent double application

      // Set up specific listener for this file's thumbnail
      const thumbnailListener = (generatedFile, preview) => {
        if (generatedFile.id === file.id) {
           // Ensure cardEl is available (it should be due to closure)
          if (cardEl && imgElement.dataset.thumbnailApplied === 'false') {
             // Apply thumbnail via generateThumbnail only for non-HEIC/HEIF
             // HEIC/HEIF gets handled post-upload via processHeicThumbnail
             if (generatedFile.type !== 'image/heic' && generatedFile.type !== 'image/heif') {
                 this.generateThumbnail(imgElement, preview, cardEl);
                 // generateThumbnail now sets the applied flag internally on success/error
             }
          }
          // Clean up this specific listener after it runs or if cardEl isn't found
           this.uppy.off('thumbnail:generated', thumbnailListener);
        }
      };
      this.uppy.on('thumbnail:generated', thumbnailListener);

        // Check if thumbnail already exists (generated before listener was attached)
      const uppyFile = this.uppy.getFile(file.id);
      if (uppyFile && uppyFile.preview && imgElement.dataset.thumbnailApplied === 'false') {
        console.log('Using existing thumbnail for', file.id);
        if (file.type !== 'image/heic' && file.type !== 'image/heif') {
          this.generateThumbnail(imgElement, uppyFile.preview, cardEl);
        }
      }

    } else {
        console.error(`displaySelectedFile [${file.id}]: Could not find .photo-print__card-image in template clone.`);
    }

    // Append the cloned template to the images grid
    imgList.appendChild(clone);
  }

  generateThumbnail(imgElement, preview, cardEl) {
    imgElement.onload = () => {
        const imgWidth = imgElement.naturalWidth;
        const imgHeight = imgElement.naturalHeight;
        if (!imgWidth || !imgHeight) return;

        const imageRatio = imgWidth / imgHeight;
        const imageIsLandscape = imgWidth > imgHeight;
        const imageIsPortrait = imgHeight > imgWidth;
        const imageOrientation = imageIsLandscape ? 'landscape' : (imageIsPortrait ? 'portrait' : 'square');

        const cardWrapper = cardEl || imgElement.closest('.photo-print__card-wrapper');
        if (!cardWrapper) {
             console.error("generateThumbnail: cardWrapper not found.");
             return;
        }

        const selectedRatioString = cardWrapper.dataset.selectedRatio;
        if (!selectedRatioString) {
            console.error("generateThumbnail: data-selected-ratio not found on cardWrapper.");
            return;
        }

        const cardImgWrapper = imgElement.closest('.photo-print__card-img-wrapper');
        if(cardImgWrapper) {
            cardImgWrapper.style.setProperty('--aspect-ratio', imageRatio);
        }

        const cropAreaElement = cardWrapper.querySelector('.pp__crop-area');
        if (cropAreaElement) {
            let effectiveRatioString = window.current_variant.title;
            const parsedSelectedRatio = this._parseRatio(window.current_variant.title);
            

            if (parsedSelectedRatio) {
                console.log(`generateThumbnail [${cardWrapper.dataset.fileUppyId}]: Image orientation=${imageOrientation}, Selected ratio=${selectedRatioString} (orientation=${parsedSelectedRatio.orientation})`);

                if (parsedSelectedRatio.orientation === 'portrait' && imageIsLandscape) {
                    effectiveRatioString = this._getInverseRatioString(parsedSelectedRatio);
                    console.log(`   -> Mismatch: Setting crop area ratio to inverse: ${effectiveRatioString}`);
                } else if (parsedSelectedRatio.orientation === 'landscape' && imageIsPortrait) {
                    effectiveRatioString = this._getInverseRatioString(parsedSelectedRatio);
                    console.log(`   -> Mismatch: Setting crop area ratio to inverse: ${effectiveRatioString}`);
                } else {
                    console.log(`   -> Match: Setting crop area ratio to selected: ${effectiveRatioString}`);
                }
            } else {
                console.warn("generateThumbnail: Could not parse selected ratio string:", selectedRatioString);
                parsedSelectedRatio.den = 1;
                parsedSelectedRatio.num = 1;
            }

            if(imageOrientation == 'square') {
              let ratio = parsedSelectedRatio.num / parsedSelectedRatio.den;
              if(parsedSelectedRatio.num > parsedSelectedRatio.den) {
                ratio = parsedSelectedRatio.den / parsedSelectedRatio.num;
              }
              cropAreaElement.style.setProperty('--ar', ratio);
            } else {
              cropAreaElement.style.setProperty('--ar', parsedSelectedRatio.den/parsedSelectedRatio.num);
            }
   
        } else {
            console.warn("generateThumbnail: .pp__crop-area element not found in card.");
        }

        const aspectContainer = imgElement.closest('.AspectRatio');
        if (aspectContainer) {
            aspectContainer.classList.remove('landscape', 'portrait', 'square');
            aspectContainer.classList.add(imageOrientation);
        }
        // Ensure the flag is set after successful application
        imgElement.dataset.thumbnailApplied = 'true';
    };

    imgElement.onerror = () => {
        console.error("Error loading thumbnail image:", preview);
         imgElement.dataset.thumbnailApplied = 'true'; // Prevent potential loops on error
    };

    imgElement.src = preview;
  }

_parseRatio(ratioString) {
  // Basic validation of input
  if (!ratioString || typeof ratioString !== 'string') {
    console.warn("_parseRatio: Input is not a valid string.", ratioString);
    return null;
  }

  let num = NaN;
  let den = NaN;

  // Trim whitespace for easier processing
  const trimmedRatioString = ratioString.trim();

  // Check if the format is like "WxH ..." (e.g., "9x13 cm", "10x15")
  if (trimmedRatioString.includes('x')) {
    // Use regex to extract width and height numbers, ignoring spaces and trailing units
    const match = trimmedRatioString.match(/^(\d+)\s*x\s*(\d+)/);
    if (match && match.length === 3) {
      num = parseInt(match[1], 10); // First captured group (width)
      den = parseInt(match[2], 10); // Second captured group (height)
    } else {
      console.warn(`_parseRatio: Could not parse 'WxH' format:`, ratioString);
      return null; // Failed to parse WxH format
    }
  }
  // Otherwise, assume the format is "W/H" (e.g., "9/13", "13/9")
  else if (trimmedRatioString.includes('/')) {
    const parts = trimmedRatioString.split('/');
    if (parts.length === 2) {
      num = parseInt(parts[0], 10); // Numerator (width)
      den = parseInt(parts[1], 10); // Denominator (height)
    } else {
       console.warn(`_parseRatio: Could not parse 'W/H' format:`, ratioString);
       return null; // Invalid W/H format
    }
  } else {
      console.warn(`_parseRatio: Unrecognized ratio format:`, ratioString);
      return null; // Format not recognized
  }

  // Validate the parsed numbers
  if (isNaN(num) || isNaN(den) || num <= 0 || den <= 0) {
     console.warn(`_parseRatio: Invalid dimensions parsed (${num}, ${den}) from:`, ratioString);
     return null;
  }

  // Determine orientation based on parsed dimensions
  let orientation = 'square';
  if (num < den) {
    orientation = 'portrait';
  } else if (num > den) {
    orientation = 'landscape';
  }

  // Return the parsed data
  return { num, den, orientation };
}

_getInverseRatioString(parsedRatio) {
  if (!parsedRatio) return null;
  return `${parsedRatio.den}/${parsedRatio.num}`;
}
}

customElements.define("photo-printing", PhotoPrinting);

/**
 * @class FabricJs
 * @extends HTMLElement
 * @description Manages Fabric.js canvas for image cropping and editing.
 */
class FabricJs extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      this.lastValidLeft = null;
      this.lastValidTop = null;
      this.scaleBeforeRotation = null;
      this.userManuallySetScale = null;
      this.canvas = null;
      this.fabricImg = null;
      this.originalImg = null;
      this.cropFrame = null;
      this.cutout = null;
      this.gridGroup = null;
      this.overlayGroup = null;
      this.imgRotate = null;
      this.cropDimensions = null;
      this.isCoverEditMode = false;

      this.touchStartDistance = null; // Distance between fingers at start
        this.touchStartAngle = null;    // Angle between fingers at start
        this.gestureStartScale = null;  // Image scale at gesture start
        this.gestureStartAngle = null;  // Image angle at gesture start
        this.isGesturing = false;       // Flag for active pinch/rotate
        this.gestureCenter = null;      // Midpoint between fingers 
  }

  connectedCallback() {
      this.init();
      this.checkLoaded();
      this.bindEvents();
      this._bindMouseUpListener();

  }

  disconnectedCallback() {

       this.delegateBody.off('mouseup', this._handleMouseUpClearRotationScale.bind(this));
       this.delegateBody.off('touchend', this._handleMouseUpClearRotationScale.bind(this));
       this._removeTouchEvents();

  }

  _removeTouchEvents() {
    if (!this.canvas || !this.canvas.upperCanvasEl) return;
    const canvasEl = this.canvas.upperCanvasEl;
    canvasEl.removeEventListener('touchstart', this._handleTouchStart);
    canvasEl.removeEventListener('touchmove', this._handleTouchMove);
    canvasEl.removeEventListener('touchend', this._handleTouchEnd);
    canvasEl.removeEventListener('touchcancel', this._handleTouchEnd);
}

_getTouchCoords(event) {
  // Get touch coordinates relative to the canvas element
  const canvasRect = this.canvas.upperCanvasEl.getBoundingClientRect();
  const touches = [];
  for (let i = 0; i < event.touches.length; i++) {
      touches.push({
          x: event.touches[i].clientX - canvasRect.left,
          y: event.touches[i].clientY - canvasRect.top
      });
  }
  return touches;
}

_getDistance(touch1, touch2) {
  const dx = touch1.x - touch2.x;
  const dy = touch1.y - touch2.y;
  return Math.sqrt(dx * dx + dy * dy);
}

_getAngle(touch1, touch2) {
  const dy = touch2.y - touch1.y;
  const dx = touch2.x - touch1.x;
  const theta = Math.atan2(dy, dx); // Range (-PI, PI]
  let angle = theta * 180 / Math.PI; // Radians to degrees
  if (angle < 0) angle = 360 + angle; // Convert to 0-360 degree range
  return angle;
}

_getCenter(touch1, touch2) {
  return {
      x: (touch1.x + touch2.x) / 2,
      y: (touch1.y + touch2.y) / 2
  };
}


// --- Touch Event Handlers ---

_handleTouchStart(event) {
  if (!this.fabricImg || event.touches.length !== 2) {
      // If only one finger, let default Fabric drag (or mouse events) handle it
      this.isGesturing = false;
      return;
  }

  // Two fingers detected - start gesture
  event.preventDefault(); // Prevent page scroll/zoom
  this.isGesturing = true;
  this.canvas.discardActiveObject(); // Deselect if anything was selected by single touch

  const touches = this._getTouchCoords(event);
  this.touchStartDistance = this._getDistance(touches[0], touches[1]);
  this.touchStartAngle = this._getAngle(touches[0], touches[1]);
  this.gestureStartScale = this.fabricImg.scaleX;
  this.gestureStartAngle = this.fabricImg.angle;
  this.gestureCenter = this._getCenter(touches[0], touches[1]); // Store center point

  // Optional: Set transform origin? Fabric's default might be okay.
  // For precise zooming around the pinch center, this is more complex.
  // Let's stick to manipulating scale/angle directly first.
}

_handleTouchMove(event) {
  if (!this.isGesturing || event.touches.length !== 2 || !this.fabricImg) {
      return; // Only process if actively gesturing with two fingers
  }

  event.preventDefault(); // Prevent page scroll/zoom

  const touches = this._getTouchCoords(event);
  const currentDistance = this._getDistance(touches[0], touches[1]);
  const currentAngle = this._getAngle(touches[0], touches[1]);

  // --- Calculate Scale ---
  const scaleFactor = currentDistance / this.touchStartDistance;
  let newScale = this.gestureStartScale * scaleFactor;

  // Apply minimum scale constraint (important!)
  const minRequiredScale = this.calculateRequiredScale(this.fabricImg, this.fabricImg.angle); // Use current angle for check
  newScale = Math.max(newScale, minRequiredScale); // Don't allow scaling smaller than needed

  this.fabricImg.scaleX = newScale;
  this.fabricImg.scaleY = newScale; // Maintain uniform scaling

  // --- Calculate Rotation ---
  const angleChange = currentAngle - this.touchStartAngle;
  let newAngle = this.gestureStartAngle + angleChange;
  this.fabricImg.angle = newAngle;

  this.clampToCrop(this.fabricImg); // Ensure it still covers the area after scale/rotate

  // Update last valid position after clamping
  this.lastValidLeft = this.fabricImg.left;
  this.lastValidTop = this.fabricImg.top;

  this.canvas.requestRenderAll();
}

_handleTouchEnd(event) {
  if (this.isGesturing) {
      if (event.touches.length < 2) {
          this.isGesturing = false;
          if (this.fabricImg) {
              this.clampToCrop(this.fabricImg);
              this.userManuallySetScale = this.fabricImg.scaleX;
              this.lastValidLeft = this.fabricImg.left;
              this.lastValidTop = this.fabricImg.top;
              this.scaleBeforeRotation = null; // Keep explicit reset
              this.canvas.requestRenderAll();
          }
          this.touchStartDistance = null;
          this.touchStartAngle = null;
          this.gestureStartScale = null;
          this.gestureStartAngle = null;
          this.gestureCenter = null;
      }
  }
}
  _bindTouchEvents() {
    if (!this.canvas || !this.canvas.upperCanvasEl) return;

    // Bind methods to ensure 'this' context is correct
    this._handleTouchStart = this._handleTouchStart.bind(this);
    this._handleTouchMove = this._handleTouchMove.bind(this);
    this._handleTouchEnd = this._handleTouchEnd.bind(this);

    const canvasEl = this.canvas.upperCanvasEl;
    canvasEl.addEventListener('touchstart', this._handleTouchStart, { passive: false });
    canvasEl.addEventListener('touchmove', this._handleTouchMove, { passive: false });
    canvasEl.addEventListener('touchend', this._handleTouchEnd, { passive: false });
    canvasEl.addEventListener('touchcancel', this._handleTouchEnd, { passive: false }); // Handle cancel too
}


  init() {
      let selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
      if (selectBoxes) selectBoxes.forEach(selectbox => new RevolutionSelectbox(selectbox));
      this.breakpoint = responsive.getCurrentBreakpoint();
      this.primaryAccentColor = getComputedStyle(document.documentElement).getPropertyValue('--primary_accent').trim();
      this.backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--background_color').trim();
      this.emtySpaceTopBottomCnv = 64;
      if (this.breakpoint === 'desktop') {
          this.emtySpaceLeftRightCnv = 64;
      } else {
          this.emtySpaceLeftRightCnv = 16;
      }
  }

  bindEvents() {
      this.delegateBody.on("edit-img:pressed", this.editImgHandleFabric.bind(this));
      this.delegateElement.on('click', '[data-action="rotate-left"]', this.rotateLeft.bind(this));
      this.delegateElement.on('click', '[data-action="rotate-right"]', this.rotateRight.bind(this));
      this.delegateElement.on('click', '[data-action="apply-landscape"]', this.setCropLandscape.bind(this));
      this.delegateElement.on('click', '[data-action="apply-portrait"]', this.setCropPortrait.bind(this));
      this.delegateElement.on('click', '[data-action="apply-changes"]', this.applyChanges.bind(this));
      this.delegateBody.on('change:size', this.selectboxChange.bind(this));
  }

  checkLoaded() {
      if (typeof fabric !== "undefined") {
          this.initializeCanvas();
      } else {
          // Assuming loadScript is globally available
          loadScript(window.theme.fabricScript);
          setTimeout(() => this.checkLoaded(), 100);
      }
  }

  selectboxChange(event) {
      const selectedOption = event.target.querySelector('option[selected]');
      if (!selectedOption) return;
      const ratioValue = selectedOption.getAttribute('data-ratio-value');
      this.recalculateCropArea(ratioValue);
      this.updateOrientationUI();
      this.editImgHandleFabric(false); // Refresh canvas state without fetching image again
  }

  initializeCanvas() {
      this.canvasElement = this.element.querySelector('#fabricCanvas');
      if (this.breakpoint === 'desktop') {
          this.canvasWidth = 517;
      } else {
          this.canvasWidth = window.innerWidth;
      }
      this.canvas = new fabric.Canvas(this.canvasElement, {
          backgroundColor: this.backgroundColor,
          selection: false,
          preserveObjectStacking: true,
          stopCanvasClicks: true
      });
      this._bindCanvasObjectEvents();
      this._bindTouchEvents();      // Bind NEW touch events
  }

  _bindCanvasObjectEvents() {
       this.canvas.on('mouse:down', (e) => {
           const target = e.target;
           if (target === this.fabricImg) {
               if (target.originX !== 'center' || target.originY !== 'center') {
                   target.set({ originX: 'center', originY: 'center' });
                   target.setCoords();
               }
               if (!this.isPositionValid(target, target.left, target.top)) {
                   this.centerImageInCrop(target);
               }
               this.lastValidLeft = target.left;
               this.lastValidTop = target.top;
           } else if (this.canvas.getActiveObject() !== this.fabricImg) {
                // Clear rotation tracker if clicking elsewhere
                this.scaleBeforeRotation = null;
           }
       });

       this.canvas.on('object:moving', (e) => {
           const target = e.target;
           if (target === this.fabricImg && this.lastValidLeft !== null) {
               const currentLeft = target.left;
               const currentTop = target.top;
               let finalLeft = currentLeft;
               let finalTop = currentTop;
               let needsCorrection = false;
               if (this.isPositionValid(target, currentLeft, currentTop)) {
                   this.lastValidLeft = currentLeft;
                   this.lastValidTop = currentTop;
               } else {
                   needsCorrection = true;
                   const canMoveVertically = this.isPositionValid(target, this.lastValidLeft, currentTop);
                   const canMoveHorizontally = this.isPositionValid(target, currentLeft, this.lastValidTop);
                   if (canMoveVertically && canMoveHorizontally) {
                       finalLeft = this.lastValidLeft;
                       finalTop = this.lastValidTop;
                   } else if (canMoveVertically) {
                       finalLeft = this.lastValidLeft;
                       finalTop = currentTop;
                       this.lastValidTop = finalTop;
                   } else if (canMoveHorizontally) {
                       finalLeft = currentLeft;
                       finalTop = this.lastValidTop;
                       this.lastValidLeft = finalLeft;
                   } else {
                       finalLeft = this.lastValidLeft;
                       finalTop = this.lastValidTop;
                   }
               }
               if (needsCorrection) {
                   const tolerance = 0.001;
                   if (Math.abs(currentLeft - finalLeft) > tolerance || Math.abs(currentTop - finalTop) > tolerance) {
                       target.left = finalLeft;
                       target.top = finalTop;
                       target.setCoords();
                   }
               }
           }
       });

       this.canvas.on('object:scaling', (e) => {
           const target = e.target;
           if (target === this.fabricImg) {
               const minRequiredScale = this.calculateRequiredScale(target, target.angle);
               const tolerance = 0.0001;
               if (target.scaleX < minRequiredScale - tolerance) {
                   target.scaleX = minRequiredScale;
                   target.scaleY = minRequiredScale;
                   target.setCoords();
               }
               this.clampToCrop(target);
               this.lastValidLeft = target.left;
               this.lastValidTop = target.top;
           }
       });

        this.canvas.on('object:scaled', (e) => {
            if (e.target === this.fabricImg) {
                this.userManuallySetScale = e.target.scaleX;
            }
        });


       this.canvas.on('object:rotating', (e) => {
           const target = e.target;
           if (target === this.fabricImg) {
               this.handleObjectRotating(target);
           }
       });
  }

  isPositionValid(obj, testLeft, testTop) {
      if (!this.cropDimensions || !obj || !obj.width || !obj.height || obj.scaleX === undefined) return false;
      const C = this.cropDimensions;
      const scaledWidth = obj.width * obj.scaleX;
      const scaledHeight = obj.height * obj.scaleY;
      const angle = obj.angle;
      const thetaRad = fabric.util.degreesToRadians(-angle);
      const cosTheta = Math.cos(thetaRad);
      const sinTheta = Math.sin(thetaRad);
      const cropCorners = [
          { x: C.left, y: C.top }, { x: C.left + C.width, y: C.top },
          { x: C.left + C.width, y: C.top + C.height }, { x: C.left, y: C.top + C.height }
      ];
      for (const corner of cropCorners) {
          const dx_world = corner.x - testLeft;
          const dy_world = corner.y - testTop;
          const local_x = dx_world * cosTheta - dy_world * sinTheta;
          const local_y = dx_world * sinTheta + dy_world * cosTheta;
          const halfW = scaledWidth / 2, halfH = scaledHeight / 2, tolerance = 0.1;
          if (local_x < -halfW - tolerance || local_x > halfW + tolerance || local_y < -halfH - tolerance || local_y > halfH + tolerance) return false;
      }
      return true;
  }

  _handleMouseUpClearRotationScale() {
    // Log when this fires to see its timing relative to _handleTouchEnd

    if (this.scaleBeforeRotation !== null) {
        this.scaleBeforeRotation = null;
    }
}

  _bindMouseUpListener() {
      this.delegateBody.on('mouseup', this._handleMouseUpClearRotationScale.bind(this));
      this.delegateBody.on('touchend', this._handleMouseUpClearRotationScale.bind(this));
  }

  _parseRatio(ratioString) {
      if (!ratioString || typeof ratioString !== 'string') return null;
      const parts = ratioString.split('/');
      if (parts.length !== 2) return null;
      const num = parseInt(parts[0], 10);
      const den = parseInt(parts[1], 10);
      if (isNaN(num) || isNaN(den) || num <= 0 || den <= 0) return null;
      let orientation = 'square';
      if (num < den) orientation = 'portrait';
      else if (num > den) orientation = 'landscape';
      return { num, den, orientation };
  }

  _getInverseRatioString(parsedRatio) {
      if (!parsedRatio) return null;
      return `${parsedRatio.den}/${parsedRatio.num}`;
  }

  handleObjectRotating(target) {
      if (target === this.fabricImg && target.width && target.height && this.cropDimensions) {
          const currentScale = target.scaleX;
          if (this.scaleBeforeRotation === null) {
              this.scaleBeforeRotation = currentScale;
          }
          const minRequiredScale = this.calculateRequiredScale(target, target.angle);
          const rotationStartScaleFloor = this.scaleBeforeRotation;
          const scaleFloor = Math.max(rotationStartScaleFloor, minRequiredScale);
          const targetScale = scaleFloor;
          const finalScale = targetScale * 1.0005;
          const tolerance = 0.00001;

          if (Math.abs(currentScale - finalScale) > tolerance) {
              target.set({ scaleX: finalScale, scaleY: finalScale });
              this.centerImageInCrop(target);
              this.lastValidLeft = target.left;
              this.lastValidTop = target.top;
          } else {
              this.clampToCrop(target);
              this.lastValidLeft = target.left;
              this.lastValidTop = target.top;
          }
      }
  }

  centerImageInCrop(obj) {
      if (!obj || !this.cropDimensions || typeof this.cropDimensions.left === 'undefined') {
          console.warn("centerImageInCrop: Object or crop dimensions missing/invalid.");
          return;
      }
      const C = this.cropDimensions;
      obj.set({
          originX: 'center', originY: 'center',
          left: C.left + C.width / 2, top: C.top + C.height / 2
      });
      obj.setCoords();
  }

  clampToCrop(obj) {
       if (!obj || !this.cropDimensions) return;
      obj.setCoords();
      const bb = obj.getBoundingRect(true, true);
      const C = this.cropDimensions;
      let dx = 0, dy = 0;
      if (bb.left > C.left) dx = C.left - bb.left;
      if (bb.top > C.top) dy = C.top - bb.top;
      if (bb.left + bb.width < C.left + C.width) dx = (C.left + C.width) - (bb.left + bb.width);
      if (bb.top + bb.height < C.top + C.height) dy = (C.top + C.height) - (bb.top + bb.height);
      if (dx !== 0 || dy !== 0) {
          obj.left += dx;
          obj.top += dy;
          obj.setCoords();
      }
  }

  calculateRequiredScale(obj, angleDegrees) {
      if (!this.cropDimensions || !obj || !obj.width || !obj.height) return 1;
      const imgWidth = obj.width;
      const imgHeight = obj.height;
      const C = this.cropDimensions;
      if (!C.width || !C.height) return 1; // Added check for valid crop dimensions
      const thetaRad = fabric.util.degreesToRadians(angleDegrees);
      const cos = Math.abs(Math.cos(thetaRad));
      const sin = Math.abs(Math.sin(thetaRad));
      const requiredImgWidth = C.width * cos + C.height * sin;
      const requiredImgHeight = C.width * sin + C.height * cos;
      const scaleBasedOnWidth = requiredImgWidth / imgWidth;
      const scaleBasedOnHeight = requiredImgHeight / imgHeight;
      return Math.max(scaleBasedOnWidth, scaleBasedOnHeight);
  }

  recalculateCropArea(ratio) {
      this.cropDimensions = {};
      const parsedRatio = this._parseRatio(ratio);
      if (!parsedRatio || !this.canvas || !this.canvas.width || !this.canvas.height) {
           console.error("Cannot recalculate crop area: Invalid ratio or canvas dimensions.");
           // Set default safe values?
           this.cropDimensions = { width: 100, height: 100, left: 0, top: 0, ratio_x:1, ratio_y:1, big_dimension: 100 };
           return;
      }

      this.cropDimensions.ratio_x = parsedRatio.num;
      this.cropDimensions.ratio_y = parsedRatio.den;

      const availableWidth = this.canvas.width - this.emtySpaceLeftRightCnv * 2; // Use * 2
      const availableHeight = this.canvas.height - this.emtySpaceTopBottomCnv * 2; // Use * 2

       if (availableWidth <= 0 || availableHeight <= 0) {
           console.warn("Canvas dimensions too small for padding.");
           this.cropDimensions = { width: 1, height: 1, left: this.canvas.width/2, top: this.canvas.height/2, ratio_x:1, ratio_y:1, big_dimension: 1 };
           return;
       }


      let maxCropWidth = availableWidth;
      if (this.isCoverEditMode) {
          if (this.breakpoint !== 'desktop') {
              maxCropWidth = 215;
          } else {
              const printAspectRatio = this.cropDimensions.ratio_x / this.cropDimensions.ratio_y;
              const desktopBaseWidth = 270;
              maxCropWidth =
                  printAspectRatio >= 1
                      ? desktopBaseWidth * printAspectRatio
                      : desktopBaseWidth;
          }
      }
      let potentialWidth = Math.min(availableWidth, maxCropWidth);
      let potentialHeight = potentialWidth * (this.cropDimensions.ratio_y / this.cropDimensions.ratio_x);

      if (potentialHeight > availableHeight) {
          potentialHeight = availableHeight;
          potentialWidth = potentialHeight * (this.cropDimensions.ratio_x / this.cropDimensions.ratio_y);
      }

      this.cropDimensions.width = potentialWidth;
      this.cropDimensions.height = potentialHeight;
      this.cropDimensions.left = (this.canvas.width - this.cropDimensions.width) / 2;
      this.cropDimensions.top = (this.canvas.height - this.cropDimensions.height) / 2;
      this.cropDimensions.big_dimension = Math.max(this.cropDimensions.width, this.cropDimensions.height);
  }

  createCropArea(ratio) {

       if (this.gridGroup) {
          this.canvas.remove(this.gridGroup);
          this.gridGroup = null;
       }

      if (!ratio) {
          const selectedOption = this.element.querySelector('.fjs__variant-select option[selected]');
          ratio = selectedOption?.getAttribute('data-ratio-value');
      }
      if (!ratio) {
           console.error("createCropArea: No valid ratio provided or found.");
           // Set default ratio?
           ratio = '1/1';
      }

      this.recalculateCropArea(ratio); // Sets this.cropDimensions

      if (!this.cropDimensions || !this.cropDimensions.width) {
          console.error("createCropArea: cropDimensions invalid after recalculate.");
          return; // Exit if dimensions are still invalid
      }


      this.cropFrame = new fabric.Rect({
          left: this.cropDimensions.left, top: this.cropDimensions.top,
          width: this.cropDimensions.width, height: this.cropDimensions.height,
          fill: 'transparent', stroke: '#F2F2F0', strokeWidth: 1,
          selectable: false, evented: false
      });

      this.createCropGrid(this.cropFrame); // Creates and assigns this.gridGroup
  }

/**
 * Creates the visual crop frame and internal grid lines, grouping them.
 * Does NOT add the group to the canvas.
 */
createCropGrid(cropFrame) {
  if (!this.cropDimensions || !cropFrame) {
      console.error("Cannot create grid: Missing dimensions or frame.");
      return;
  }
  this.cutout = new fabric.Rect({
      left: this.cropDimensions.left, top: this.cropDimensions.top,
      width: this.cropDimensions.width, height: this.cropDimensions.height,
      fill: 'black', globalCompositeOperation: 'destination-out',
      selectable: false, evented: false
  });
  const lineOption = {
      stroke: '#F2F2F0', strokeWidth: 1,
      selectable: false, evented: false, originX: 'left', originY: 'top'
  };
  const C = this.cropDimensions;
  const vLines = [
      new fabric.Line([C.left + C.width / 3, C.top, C.left + C.width / 3, C.top + C.height], lineOption),
      new fabric.Line([C.left + C.width * 2 / 3, C.top, C.left + C.width * 2 / 3, C.top + C.height], lineOption)
  ];
  const hLines = [
      new fabric.Line([C.left, C.top + C.height / 3, C.left + C.width, C.top + C.height / 3], lineOption),
      new fabric.Line([C.left, C.top + C.height * 2 / 3, C.left + C.width, C.top + C.height * 2 / 3], lineOption)
  ];
  this.gridGroup = new fabric.Group([cropFrame, ...vLines, ...hLines], {
      selectable: false, evented: false
  });
}

  applyChanges(event) {
      if (this.isCoverEditMode) {
          const closeBtn = this.element.querySelector('#modal-edit-img .fjs__close-btn');
          const dataUrl = this.getCroppedImageDataUrl();
          if (dataUrl) {
              this.element.dispatchEvent(
                  new CustomEvent("cover-image:edited", {
                      bubbles: true,
                      detail: { dataUrl }
                  })
              );
          }
          if (closeBtn) closeBtn.click();
          return;
      }

      const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
      const closeBtn = this.element.querySelector('#modal-edit-img .fjs__close-btn');
      if (!selectedOption) { console.warn('No selected option found'); return; }

      const variantId = selectedOption.getAttribute('data-variant-id');
      const variantValue = selectedOption.value;

      const eanCode = selectedOption.getAttribute('data-barcode');
      const imgCardId = event.target.dataset.imgCardId;
      const orientation = this.element.querySelector('[data-action="apply-landscape"]').classList.contains('selected') ? 'landscape' : 'portrait';
      const card = document.body.querySelector(`[data-file-uppy-id="${imgCardId}"]`);
      if (card) { card.setAttribute("data-orientation", orientation); }

      this.element.dispatchEvent(new CustomEvent("update:main-atc", {
          bubbles: true,
          detail: { eventName: "updata-main-atc", variantId, variantValue, cardId: imgCardId },
      }));
      this.cropImageHighQuality(variantValue, eanCode);
      if (closeBtn) { closeBtn.click(); }
  }

  editImgHandleFabric(event) {
      this.isCoverEditMode = Boolean(event && event.detail && event.detail.coverMode);
      const editPopup = this.element.querySelector('#modal-edit-img');
      if (editPopup) {
          editPopup.dataset.coverMode = this.isCoverEditMode ? "true" : "false";
      }
      const imgUrl = this.element.querySelector('.fabric-js__popup')?.getAttribute('data-img-url');
      let imgCardId = null;
      if (event !== false && event && event.detail) { imgCardId = event.detail.imgCardId; }

      const applyBtn = this.element.querySelectorAll('[data-action="apply-changes"]');
      if (!imgUrl) { console.error('editImgHandleFabric: No image URL found'); return; }
      if (applyBtn && imgCardId) { 
          applyBtn.forEach(btn => btn.setAttribute('data-img-card-id', imgCardId)); // Set for all buttons

      }
      else if (applyBtn && !imgCardId && event !== false) {

           imgCardId = applyBtn[0].getAttribute('data-img-card-id');
      }


      const imgElement = new Image();
      imgElement.crossOrigin = 'Anonymous';
      imgElement.src = imgUrl;
      this.canvas.clear();
      this.fabricImg = null; this.originalImg = null;
      this.userManuallySetScale = null; this.scaleBeforeRotation = null;

      imgElement.onload = () => {
          this.originalImg = imgElement;
          const imgWidth = imgElement.naturalWidth;
          const imgHeight = imgElement.naturalHeight;
          if (!imgWidth || !imgHeight) { console.error("Image dimensions invalid."); return; }

          let effectiveRatioString = '1/1'; // Default
          const selectedOption = this.element.querySelector('.fjs__variant-select option[selected]');
          const selectedRatioString = selectedOption?.getAttribute('data-ratio-value');
          const parsedSelectedRatio = this._parseRatio(selectedRatioString);

          if (parsedSelectedRatio) {
              effectiveRatioString = selectedRatioString;
              const imageIsLandscape = imgWidth > imgHeight;
              const imageIsPortrait = imgHeight > imgWidth;
              if (parsedSelectedRatio.orientation === 'portrait' && imageIsLandscape) {
                  effectiveRatioString = this._getInverseRatioString(parsedSelectedRatio);
              } else if (parsedSelectedRatio.orientation === 'landscape' && imageIsPortrait) {
                  effectiveRatioString = this._getInverseRatioString(parsedSelectedRatio);
              }
          } else { console.warn("Could not parse selected ratio. Using 1/1."); }

          const canvasContainer = this.element.querySelector('.fabric-js__img-content');
          if (!canvasContainer) { console.error("Canvas container not found."); return; }

          if (this.breakpoint === 'desktop') {
              this.canvasWidth = 517; this.canvasHeight = 517;
          } else {
              const verticalInset = 128; // 4rem top + 4rem bottom
              const maxCanvasHeight = window.innerHeight - 129 - 52;
              const minimumCanvasHeight = 215 + verticalInset;
              this.canvasWidth = canvasContainer.offsetWidth;
              const referenceImageWidth = 215;
              const aspectRatio = imgHeight / imgWidth;
              const imageDisplayHeight =
                  aspectRatio > 1 ? referenceImageWidth * aspectRatio : referenceImageWidth;
              const preferredCanvasHeight = imageDisplayHeight + verticalInset;
              this.canvasHeight = Math.max(
                  minimumCanvasHeight,
                  Math.min(preferredCanvasHeight, maxCanvasHeight)
              );
          }
          this.canvas.setWidth(this.canvasWidth); this.canvas.setHeight(this.canvasHeight);

          this.createCropArea(effectiveRatioString);
          this.updateOverlayGroup();
          this._initializeFabricImage(imgElement);

          if (this.fabricImg) {
              this.renderingImage();
              this.lastValidLeft = this.fabricImg.left;
              this.lastValidTop = this.fabricImg.top;
              this.canvas.setActiveObject(this.fabricImg);
          } else { console.error("Fabric image failed to initialize."); return; }

          this.updateOrientationUI(effectiveRatioString);

      };

      imgElement.onerror = () => { console.error('Failed to load image for editing:', imgUrl); };
  }

getCroppedImageDataUrl() {
  if (!this.originalImg || !this.fabricImg || !this.cropDimensions || !this.canvas) return null;
  if (!this.fabricImg.width || !this.fabricImg.height) return null;

  const displayedWidth = this.fabricImg.getScaledWidth();
  if (displayedWidth <= 0) return null;

  const multiplier = this.originalImg.naturalWidth / displayedWidth;
  const cropFullWidth = this.cropDimensions.width * multiplier;
  const cropFullHeight = this.cropDimensions.height * multiplier;
  const cropCenterX_preview = this.cropDimensions.left + this.cropDimensions.width / 2;
  const cropCenterY_preview = this.cropDimensions.top + this.cropDimensions.height / 2;
  const imgCenterX_preview = this.fabricImg.left;
  const imgCenterY_preview = this.fabricImg.top;
  const deltaX_preview = cropCenterX_preview - imgCenterX_preview;
  const deltaY_preview = cropCenterY_preview - imgCenterY_preview;
  const deltaX_full = deltaX_preview * multiplier;
  const deltaY_full = deltaY_preview * multiplier;

  const offscreenCanvasEl = document.createElement("canvas");
  offscreenCanvasEl.width = Math.round(cropFullWidth);
  offscreenCanvasEl.height = Math.round(cropFullHeight);
  const ctx = offscreenCanvasEl.getContext('2d');
  if (!ctx) return null;

  ctx.fillStyle = this.backgroundColor || 'white';
  ctx.fillRect(0, 0, offscreenCanvasEl.width, offscreenCanvasEl.height);
  ctx.translate(offscreenCanvasEl.width / 2, offscreenCanvasEl.height / 2);
  ctx.rotate(fabric.util.degreesToRadians(this.fabricImg.angle));
  const drawX = -deltaX_full - (this.originalImg.naturalWidth / 2);
  const drawY = -deltaY_full - (this.originalImg.naturalHeight / 2);
  ctx.drawImage(this.originalImg, drawX, drawY, this.originalImg.naturalWidth, this.originalImg.naturalHeight);

  return offscreenCanvasEl.toDataURL("image/jpeg", 0.9);
}

/**
 * Adds necessary objects (image, overlay, grid) to the canvas if missing,
 * sets their Z-index layering order, and renders the canvas.
 */
_updateObjectLayering() {
  // Add this check early
  if (!this.canvas) {
      console.error("FabricJs Error: _updateObjectLayering called but this.canvas is null or undefined!");
      return;
  }

  // Add objects if they exist but aren't on the canvas
  if (this.fabricImg && !this.canvas.contains(this.fabricImg)) {
    this.canvas.add(this.fabricImg);
  }
  if (this.overlayGroup && !this.canvas.contains(this.overlayGroup)) {
      this.canvas.add(this.overlayGroup);
  }
  if (this.gridGroup && !this.canvas.contains(this.gridGroup)) {
      this.canvas.add(this.gridGroup);
  }

  // Set Layering Order (Bottom to Top: Image -> Overlay -> Grid)



  if (this.overlayGroup) {
       if (typeof this.canvas.bringObjectToFront === 'function') {
           this.canvas.bringObjectToFront(this.overlayGroup); // Overlay is now top
       } else {
          console.error("FabricJs Error: this.canvas.bringToFront is NOT a function (for overlay)!", this.canvas);
       }
  }
  if (this.gridGroup) {
      if (typeof this.canvas.bringObjectToFront === 'function') {
           this.canvas.bringObjectToFront(this.gridGroup); // Grid is now top (above overlay)
       } else {
          console.error("FabricJs Error: this.canvas.bringToFront is NOT a function (for grid)!", this.canvas);
       }
  }

  if (typeof this.canvas.requestRenderAll === 'function') {
      this.canvas.requestRenderAll(); // Use requestRenderAll for better performance potentially
  } else {
      console.error("FabricJs Error: this.canvas.requestRenderAll is NOT a function!", this.canvas);
  }
}

  getRotateControlPlacement(imgElement) {
      const width = imgElement?.naturalWidth || 0;
      const height = imgElement?.naturalHeight || 0;

      // Keep rotate handle in the area with most free space:
      // portrait -> right side, landscape/square -> top.
      if (height > width) {
          return { x: 0.5, y: 0, offsetX: 25, offsetY: 0 };
      }

      return { x: 0, y: -0.5, offsetX: 0, offsetY: -25 };
  }

  _initializeFabricImage(imgElement){
      const rotateIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiIHRyYW5zZm9ybT0icm90YXRlKC05MCAwLjUgMjQpIiBmaWxsPSIjOEVBQkMyIi8+CjxwYXRoIGQ9Ik0xMC4xNzcyIDE1LjRMMTAuMTc3MiAxNi42MTRDOS4xNzczOCAxNi4wNzY5IDguMzgwOTcgMTUuMjA4NSA3LjkxNTU1IDE0LjE0NzlDNy40NTAxMiAxMy4wODc0IDcuMzQyNjMgMTEuODk2IDcuNjEwMjkgMTAuNzY0N0M3Ljg3Nzk1IDkuNjMzNSA4LjUwNTI3IDguNjI3ODcgOS4zOTE3MyA3LjkwODk5QzEwLjI3ODIgNy4xOTAxIDExLjM3MjUgNi43OTk1OCAxMi40OTkyIDYuOEwxMi40OTkyIDZDMTEuMjIxMSA2LjAwMTE3IDkuOTc5MSA2LjQzODI3IDguOTY1ODggNy4yNDM0OEM3Ljk1MjY1IDguMDQ4NyA3LjIyNDg2IDkuMTc3MDEgNi44OTU0IDEwLjQ1MzRDNi41NjU5NCAxMS43Mjk3IDYuNjUzMjQgMTMuMDgyOCA3LjE0Mzc1IDE0LjMwMjdDNy42MzQyNiAxNS41MjI1IDguNTAwNTYgMTYuNTQxIDkuNjA4MjYgMTcuMkw4LjQzNTYyIDE3LjJMOC40MzU2MiAxOEwxMC45NTEyIDE4TDEwLjk1MTIgMTUuNEwxMC4xNzcyIDE1LjRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTQuODIyMSA4LjZMMTQuODIyMSA3LjM4NkMxNS44MjE4IDcuOTIzMDggMTYuNjE4MiA4Ljc5MTQ4IDE3LjA4MzcgOS44NTIwNkMxNy41NDkxIDEwLjkxMjYgMTcuNjU2NiAxMi4xMDQgMTcuMzg4OSAxMy4yMzUzQzE3LjEyMTMgMTQuMzY2NSAxNi40OTQgMTUuMzcyMSAxNS42MDc1IDE2LjA5MUMxNC43MjEgMTYuODA5OSAxMy42MjY4IDE3LjIwMDQgMTIuNSAxNy4yTDEyLjUgMThDMTMuNzc4MSAxNy45OTg4IDE1LjAyMDEgMTcuNTYxNyAxNi4wMzMzIDE2Ljc1NjVDMTcuMDQ2NiAxNS45NTEzIDE3Ljc3NDQgMTQuODIzIDE4LjEwMzggMTMuNTQ2NkMxOC40MzMzIDEyLjI3MDMgMTguMzQ2IDEwLjkxNzIgMTcuODU1NSA5LjY5NzMzQzE3LjM2NSA4LjQ3NzQ4IDE2LjQ5ODcgNy40NTkwMyAxNS4zOTEgNi44TDE2LjU2MzYgNi44TDE2LjU2MzYgNkwxNC4wNDggNkwxNC4wNDggOC42TDE0LjgyMjEgOC42WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
      this.imgRotate = document.createElement('img');
      this.imgRotate.src = rotateIcon; // Consider onload for safety
      const rotatePlacement = this.getRotateControlPlacement(imgElement);

      this.fabricImg = new fabric.Image(imgElement, {
          left: this.emtySpaceLeftRightCnv, top: this.emtySpaceTopBottomCnv,
          hasRotatingPoint: false, hasControls: true, selectable: true,
          borderColor: this.primaryAccentColor, cornerColor: this.primaryAccentColor,
          cornerSize: 18, transparentCorners: false, cornerStyle: 'circle',
          scaleX: 1, scaleY: 1, lockUniScaling: true, uniScaleTransform: true,
          centeredScaling: true, centeredRotation: true, objectCaching: false
      });
      this.fabricImg.setControlsVisibility({ 'mt': false, 'mb': false, 'ml': false, 'mr': false, 'mtr': false });
      this.fabricImg.controls.rotating = new fabric.Control({
          x: rotatePlacement.x, y: rotatePlacement.y,
          offsetX: rotatePlacement.offsetX, offsetY: rotatePlacement.offsetY,
          cursorStyle: 'crosshair',
          actionHandler: fabric.controlsUtils.rotationWithSnapping, actionName: 'rotate',
          render: this.renderIcon.bind(this), cornerSize: 24, withConnection: true
      });
  }

  cropImageHighQuality(size, eanCode) {
      if (!this.originalImg || !this.fabricImg || !this.cropDimensions || !this.canvas) { console.error("Crop prerequisites missing."); return; }
      if (!this.fabricImg.width || !this.fabricImg.height) { console.error("Fabric image dimensions missing."); return; }

      const displayedWidth = this.fabricImg.getScaledWidth();
      if (displayedWidth <= 0) { console.error("Invalid preview width."); return; }
      const multiplier = this.originalImg.naturalWidth / displayedWidth;
      const cropFullWidth = this.cropDimensions.width * multiplier;
      const cropFullHeight = this.cropDimensions.height * multiplier;
      const cropCenterX_preview = this.cropDimensions.left + this.cropDimensions.width / 2;
      const cropCenterY_preview = this.cropDimensions.top + this.cropDimensions.height / 2;
      const imgCenterX_preview = this.fabricImg.left;
      const imgCenterY_preview = this.fabricImg.top;
      const deltaX_preview = cropCenterX_preview - imgCenterX_preview;
      const deltaY_preview = cropCenterY_preview - imgCenterY_preview;
      const deltaX_full = deltaX_preview * multiplier;
      const deltaY_full = deltaY_preview * multiplier;

      const offscreenCanvasEl = document.createElement("canvas");
      offscreenCanvasEl.width = Math.round(cropFullWidth);
      offscreenCanvasEl.height = Math.round(cropFullHeight);
      const ctx = offscreenCanvasEl.getContext('2d');
      if (!ctx) { console.error("Could not get 2D context."); return; }

      ctx.fillStyle = this.backgroundColor || 'white';
      ctx.fillRect(0, 0, offscreenCanvasEl.width, offscreenCanvasEl.height);
      ctx.translate(offscreenCanvasEl.width / 2, offscreenCanvasEl.height / 2);
      ctx.rotate(fabric.util.degreesToRadians(this.fabricImg.angle));
      const drawX = -deltaX_full - (this.originalImg.naturalWidth / 2);
      const drawY = -deltaY_full - (this.originalImg.naturalHeight / 2);
      ctx.drawImage(this.originalImg, drawX, drawY, this.originalImg.naturalWidth, this.originalImg.naturalHeight);

      const dataUrl = offscreenCanvasEl.toDataURL("image/jpeg", 0.9);
      this.saveImageToServer(dataUrl, size, eanCode);
  }

  renderingImage() {
      const img = this.fabricImg;
      if (!img || !this.cropDimensions || !this.canvas || !img.width || !img.height) { console.warn("Rendering prerequisites missing."); return; }
      const { width: cropW, height: cropH } = this.cropDimensions;
      const scaleX = cropW / img.width; const scaleY = cropH / img.height;
      const coverScale = Math.max(scaleX, scaleY);
      img.set({ scaleX: coverScale, scaleY: coverScale });
      if (this.userManuallySetScale === null) { this.userManuallySetScale = coverScale; }
      this.centerImageInCrop(img);
      if (!this.canvas.contains(img)) { this.canvas.add(img); }
      this.canvas.setActiveObject(img);
      this._updateObjectLayering(); // Centralized layering call
  }

  async dataURLToBlob(dataURL) {
      try {
           const response = await fetch(dataURL);
           return await response.blob();
      } catch (e) {
           console.error("Error converting data URL to Blob:", e);
           // Fallback to manual method if fetch fails (e.g., very large data URI)
           const [header, base64] = dataURL.split(',');
           if (!header || !base64) throw new Error("Invalid data URL");
           const mime = header.match(/:(.*?);/)?.[1];
           if (!mime) throw new Error("Cannot parse MIME type");
           const binary = atob(base64);
           const array = new Uint8Array(binary.length);
           for (let i = 0; i < binary.length; i++) { array[i] = binary.charCodeAt(i); }
           return new Blob([array], { type: mime });
      }
  }

  async saveImageToServer(dataUrl, size, eanCode) {
      try {
          const blob = await this.dataURLToBlob(dataUrl);
          const formData = new FormData();
          const modal = this.element.querySelector('#modal-edit-img');
          const originalFileName = modal?.dataset.name || 'edited-image';
          const fileExtension = blob.type.split('/')[1] || 'jpg';
          const finalFileName = `${originalFileName}_${size}.${fileExtension}`; // Use better name
          formData.append("file", blob, finalFileName);

          await apiService.saveEditedImage(size, originalFileName, formData, eanCode); // Pass original name maybe? Check API
          this.generateThumbnail(blob, 500, originalFileName); // Pass original name to find card
       } catch (error) {
           console.error("Error saving image or generating thumbnail:", error);
       }
  }

  generateThumbnail(blob, thumbnailWidth = 500, filename) {
       // This function seems okay, primarily updates external UI based on filename
       // Keep as is for now, assuming it works for the card update part.
       return new Promise((resolve, reject) => {
          const objectUrl = URL.createObjectURL(blob);
          const img = new Image(); img.crossOrigin = 'Anonymous';
          img.onload = () => {
              const aspectRatio = img.width / img.height;
              const thumbnailHeight = thumbnailWidth / aspectRatio;
              const canvas = document.createElement('canvas');
              canvas.width = thumbnailWidth; canvas.height = thumbnailHeight;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
              canvas.toBlob((thumbnailBlob) => {
                  URL.revokeObjectURL(objectUrl);
                  if (thumbnailBlob) { resolve(thumbnailBlob); }
                  else { reject(new Error('Thumbnail generation failed.')); }
              }, 'image/png'); // Consider image/jpeg for smaller size?
          };
          img.onerror = (err) => { URL.revokeObjectURL(objectUrl); reject(err); };

          const card = document.querySelector(`[data-file-server-id="${filename}"]`);
          if (!card) { reject(new Error(`Card not found for ${filename}`)); return;}
          const cardImg = card.querySelector('img');
          if(cardImg) cardImg.src = objectUrl; // Update src immediately for preview
          card.querySelector('.crop__area')?.remove();
          card.querySelector('.pp__edited')?.classList.add('is-visible');
      });
  }

  renderIcon(ctx, left, top, styleOverride, fabricObject) {
      const size = this.cornerSize || 24; // Use a property if defined, else default
      if (!this.imgRotate || !this.imgRotate.complete || !this.imgRotate.naturalWidth) {
          // Draw fallback if icon not loaded
           ctx.save();
           ctx.translate(left, top);
           ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
           ctx.fillStyle = this.primaryAccentColor || 'red';
           ctx.fillRect(-size / 2, -size / 2, size, size);
           ctx.restore();
           return;
      }
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(this.imgRotate, -size / 2, -size / 2, size, size);
      ctx.restore();
  }

  rotateLeft() { this.rotateByStep(-1); }
  rotateRight() { this.rotateByStep(+1); }

  rotateByStep(step) {
    let obj = this.canvas?.getActiveObject();

    if (!obj && this.fabricImg && this.canvas) {
        this.canvas.setActiveObject(this.fabricImg);
        obj = this.canvas.getActiveObject();
    }

    if (!obj || obj !== this.fabricImg || !this.cropDimensions || !this.canvas || !obj.width || !obj.height) {

        return;
    }

    const currentAngle = obj.angle;
    const nearestMultiple = Math.round(currentAngle / 90);
    let targetAngle = (nearestMultiple + step) * 90;
    targetAngle = (targetAngle % 360 + 360) % 360;

    const minRequiredScale = this.calculateRequiredScale(obj, targetAngle);
    const requiredScaleWithBuffer = minRequiredScale * 1.0005;

    obj.set('angle', targetAngle);

    const currentScale = obj.scaleX;
    const tolerance = 0.00001;
    if (currentScale < requiredScaleWithBuffer - tolerance) {
        obj.set({ scaleX: requiredScaleWithBuffer, scaleY: requiredScaleWithBuffer });
    }

    this.userManuallySetScale = null;

    this.centerImageInCrop(obj);

    this.lastValidLeft = obj.left;
    this.lastValidTop = obj.top;
    obj.setCoords();

    this.canvas.requestRenderAll();
}

  updateOverlayGroup() {
       if (!this.canvas || !this.cropDimensions || typeof this.cropDimensions.left === 'undefined') return; // Add checks

      if (this.overlayGroup) { this.canvas.remove(this.overlayGroup); }
      const overlay = new fabric.Rect({
          left: 0, top: 0, width: this.canvas.width, height: this.canvas.height,
          fill: 'rgba(255,255,255,0.5)', selectable: false, evented: false
      });
       // Ensure cutout uses current cropDimensions
       if (!this.cutout || this.cutout.left !== this.cropDimensions.left || this.cutout.top !== this.cropDimensions.top) {
            this.cutout = new fabric.Rect({
               left: this.cropDimensions.left, top: this.cropDimensions.top,
               width: this.cropDimensions.width, height: this.cropDimensions.height,
               fill: 'black', globalCompositeOperation: 'destination-out',
               selectable: false, evented: false
           });
       } else {
            // Update existing cutout dimensions if needed
            this.cutout.set({
                left: this.cropDimensions.left, top: this.cropDimensions.top,
                width: this.cropDimensions.width, height: this.cropDimensions.height
            });
       }

      this.overlayGroup = new fabric.Group([overlay, this.cutout], {
          selectable: false, evented: false
      });
      // Let _updateObjectLayering handle adding/layering
  }

  updateOrientationUI(ratioToUse = null) {
      let ratioValue = ratioToUse;
      if (!ratioValue) {
          const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
          if (!selectedOption) return;
          ratioValue = selectedOption.getAttribute('data-ratio-value');
      }
      const parsedRatio = this._parseRatio(ratioValue);
      if (!parsedRatio) return;
      const btnWrapper = this.element.querySelector('.fjs__btns-wrapper');
      if (!btnWrapper) return;
      const btnLandscape = this.element.querySelector('[data-action="apply-landscape"]');
      const btnPortrait = this.element.querySelector('[data-action="apply-portrait"]');
      if (!btnLandscape || !btnPortrait) return;

      if (parsedRatio.orientation === 'square') {
          this.element.querySelector('#layout__label').classList.add('hidden');
          btnWrapper.querySelectorAll('.fjs__btn-layout').forEach(btn => btn.classList.add('hidden'));
      } else {
        this.element.querySelector('#layout__label').classList.remove('hidden');
          btnWrapper.querySelectorAll('.fjs__btn-layout').forEach(btn => btn.classList.remove('hidden'));
          if (parsedRatio.orientation === 'landscape') {
              btnLandscape.classList.add('selected'); btnPortrait.classList.remove('selected');
          } else {
              btnLandscape.classList.remove('selected'); btnPortrait.classList.add('selected');
          }
      }
  }

  setCropLandscape() {
      const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
      if (!selectedOption || !this.canvas) return;
      let ratio = selectedOption.getAttribute('data-ratio-value');
      const parsedRatio = this._parseRatio(ratio);
      if (!parsedRatio) return;
      if (parsedRatio.orientation === 'portrait') { ratio = this._getInverseRatioString(parsedRatio); }

      this.createCropArea(ratio); // Recalcs dimensions, creates gridGroup/cutout
      this.updateOverlayGroup(); // Creates overlayGroup

      if (this.fabricImg) {
          const currentAngle = this.fabricImg.angle;
          const currentScale = this.fabricImg.scaleX;
          const minRequiredScale = this.calculateRequiredScale(this.fabricImg, currentAngle);
          const finalScale = minRequiredScale * 1.0005;
          const tolerance = 0.00001;
          if (Math.abs(currentScale - finalScale) > tolerance) {
               this.fabricImg.set({ scaleX: finalScale, scaleY: finalScale });
          }
          this.centerImageInCrop(this.fabricImg);
          this.lastValidLeft = this.fabricImg.left; this.lastValidTop = this.fabricImg.top;
      }
      this.element.querySelector('[data-action="apply-landscape"]').classList.add('selected');
      this.element.querySelector('[data-action="apply-portrait"]').classList.remove('selected');
      this._updateObjectLayering(); // Apply layering
  }

  setCropPortrait() {
      const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
      if (!selectedOption || !this.canvas) return;
      let ratio = selectedOption.getAttribute('data-ratio-value');
      const parsedRatio = this._parseRatio(ratio);
      if (!parsedRatio) return;
      if (parsedRatio.orientation === 'landscape') { ratio = this._getInverseRatioString(parsedRatio); }

      this.createCropArea(ratio); // Recalcs dimensions, creates gridGroup/cutout
      this.updateOverlayGroup(); // Creates overlayGroup

      if (this.fabricImg) {
          const currentAngle = this.fabricImg.angle;
          const currentScale = this.fabricImg.scaleX;
          const minRequiredScale = this.calculateRequiredScale(this.fabricImg, currentAngle);
          const finalScale = minRequiredScale * 1.0005;
          const tolerance = 0.00001;
          if (Math.abs(currentScale - finalScale) > tolerance) {
               this.fabricImg.set({ scaleX: finalScale, scaleY: finalScale });
          }
          this.centerImageInCrop(this.fabricImg);
          this.lastValidLeft = this.fabricImg.left; this.lastValidTop = this.fabricImg.top;
      }
      this.element.querySelector('[data-action="apply-landscape"]').classList.remove('selected');
      this.element.querySelector('[data-action="apply-portrait"]').classList.add('selected');
      this._updateObjectLayering(); // Apply layering
  }
}
customElements.define('fabric-js', FabricJs);


